var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect0, _rect1, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _rect25, _rect26, _rect27, _rect28, _rect29, _rect30, _rect31, _rect32, _rect33, _rect34, _rect35, _rect36, _rect37, _rect38, _rect39, _rect40, _rect41, _rect42, _rect43, _rect44, _rect45, _rect46, _rect47, _rect48, _rect49, _rect50, _rect51, _rect52, _rect53, _rect54, _rect55, _rect56, _rect57, _rect58, _rect59, _rect60, _rect61, _rect62, _rect63, _rect64, _rect65, _rect66, _rect67, _rect68, _rect69, _rect70, _rect71, _rect72, _rect73, _rect74, _rect75, _rect76, _rect77, _rect78, _rect79, _rect80, _rect81, _rect82, _rect83, _rect84, _rect85, _rect86, _rect87, _rect88, _rect89, _rect90, _rect91, _rect92, _rect93, _rect94, _rect95, _rect96, _rect97, _rect98, _rect99, _rect100, _rect101, _rect102, _rect103, _rect104, _rect105, _rect106, _rect107, _rect108, _rect109, _rect110, _rect111, _rect112, _rect113, _rect114, _rect115, _rect116, _rect117, _rect118, _rect119, _rect120, _rect121, _rect122, _rect123, _rect124, _rect125, _rect126, _rect127, _rect128, _rect129, _rect130, _rect131, _rect132, _rect133, _rect134, _rect135, _rect136, _rect137, _rect138, _rect139, _rect140, _rect141, _rect142, _rect143, _rect144, _rect145, _rect146, _rect147, _rect148, _rect149, _rect150, _rect151, _rect152, _rect153, _rect154, _rect155, _rect156, _rect157, _rect158, _rect159, _rect160, _rect161, _rect162, _rect163, _rect164, _rect165, _rect166, _rect167, _rect168, _rect169, _rect170, _rect171, _rect172, _rect173, _rect174, _rect175, _rect176, _rect177, _rect178, _rect179, _rect180, _rect181, _rect182, _rect183, _rect184, _rect185, _rect186, _rect187, _rect188, _rect189, _rect190, _rect191, _rect192, _rect193, _rect194, _rect195, _rect196, _rect197, _rect198, _rect199, _rect200, _rect201, _rect202, _rect203, _rect204, _rect205, _rect206, _rect207, _rect208, _rect209, _rect210, _rect211, _rect212, _rect213, _rect214, _rect215, _rect216, _rect217, _rect218, _rect219, _rect220, _rect221, _rect222, _rect223, _rect224, _rect225, _rect226, _rect227, _rect228, _rect229, _rect230, _rect231, _rect232, _rect233, _rect234, _rect235, _rect236, _rect237, _rect238, _rect239, _rect240, _rect241, _rect242, _rect243, _rect244, _rect245, _rect246, _rect247, _rect248, _rect249, _rect250, _rect251, _rect252, _rect253, _rect254, _rect255, _rect256, _rect257, _rect258, _rect259, _rect260, _rect261, _rect262, _rect263, _rect264, _rect265, _rect266, _rect267, _rect268, _rect269, _rect270, _rect271, _rect272, _rect273, _rect274, _rect275, _rect276, _rect277, _rect278, _rect279, _rect280, _rect281, _rect282, _rect283, _rect284, _rect285, _rect286, _rect287, _rect288, _rect289, _rect290, _rect291, _rect292, _rect293, _rect294, _rect295, _rect296, _rect297, _rect298, _rect299, _rect300, _rect301, _rect302, _rect303, _rect304, _rect305, _rect306, _rect307, _rect308, _rect309, _rect310, _rect311, _rect312, _rect313, _rect314, _rect315, _rect316, _rect317, _rect318, _rect319, _rect320, _rect321, _rect322, _rect323, _rect324, _rect325, _rect326, _rect327, _rect328, _rect329, _rect330, _rect331, _rect332, _rect333, _rect334, _rect335, _rect336, _rect337, _rect338, _rect339, _rect340, _rect341, _rect342, _rect343, _rect344, _rect345, _rect346, _rect347, _rect348, _rect349, _rect350, _rect351, _rect352, _rect353, _rect354, _rect355, _rect356, _rect357, _rect358, _rect359, _rect360, _rect361, _rect362, _rect363, _rect364, _rect365, _rect366, _rect367, _rect368, _rect369, _rect370, _rect371, _rect372, _rect373, _rect374, _rect375, _rect376, _rect377, _rect378, _rect379, _rect380, _rect381, _rect382, _rect383, _rect384, _rect385, _rect386, _rect387, _rect388, _rect389, _rect390, _rect391, _rect392, _rect393, _rect394, _rect395, _rect396, _rect397, _rect398, _rect399, _rect400, _rect401, _rect402, _rect403, _rect404, _rect405, _rect406, _rect407, _rect408, _rect409, _rect410, _rect411, _rect412, _rect413, _rect414, _rect415, _rect416, _rect417, _rect418, _rect419, _rect420, _rect421, _rect422, _rect423, _rect424, _rect425, _rect426, _rect427, _rect428, _rect429, _rect430, _rect431, _rect432, _rect433, _rect434, _rect435, _rect436, _rect437, _rect438, _rect439, _rect440, _rect441, _rect442, _rect443, _rect444, _rect445, _rect446, _rect447, _rect448, _rect449, _rect450, _rect451, _rect452, _rect453, _rect454, _rect455, _rect456, _rect457, _rect458, _rect459, _rect460, _rect461, _rect462, _rect463, _rect464, _rect465, _rect466, _rect467, _rect468, _rect469, _rect470, _rect471, _rect472, _rect473, _rect474, _rect475, _rect476, _rect477, _rect478, _rect479, _rect480, _rect481, _rect482, _rect483, _rect484, _rect485, _rect486, _rect487, _rect488, _rect489, _rect490, _rect491, _rect492, _rect493, _rect494, _rect495, _rect496, _rect497, _rect498, _rect499, _rect500, _rect501, _rect502, _rect503, _rect504, _rect505, _rect506, _rect507, _rect508, _rect509, _rect510, _rect511, _rect512, _rect513, _rect514, _rect515, _rect516, _rect517, _rect518, _rect519, _rect520, _rect521, _rect522, _rect523, _rect524, _rect525, _rect526, _rect527, _rect528, _rect529, _rect530, _rect531, _rect532, _rect533, _rect534, _rect535, _rect536, _rect537, _rect538, _rect539, _rect540, _rect541, _rect542, _rect543, _rect544, _rect545, _rect546, _rect547, _rect548, _rect549, _rect550, _rect551, _rect552, _rect553, _rect554, _rect555, _rect556, _rect557, _rect558, _rect559, _rect560, _rect561, _rect562, _rect563, _rect564, _rect565, _rect566, _rect567, _rect568, _rect569, _rect570, _rect571, _rect572, _rect573, _rect574, _rect575, _rect576, _rect577, _rect578, _rect579, _rect580, _rect581, _rect582, _rect583, _rect584, _rect585, _rect586, _rect587, _rect588, _rect589, _rect590, _rect591, _rect592, _rect593, _rect594, _rect595, _rect596, _rect597, _rect598, _rect599, _rect600, _rect601, _rect602, _rect603, _rect604, _rect605, _rect606, _rect607, _rect608, _rect609, _rect610, _rect611, _rect612, _rect613, _rect614, _rect615, _rect616, _rect617, _rect618, _rect619, _rect620, _rect621, _rect622, _rect623, _rect624, _rect625, _rect626, _rect627, _rect628, _rect629, _rect630, _rect631, _rect632, _rect633, _rect634, _rect635, _rect636, _rect637, _rect638, _rect639, _rect640, _rect641, _rect642, _rect643, _rect644, _rect645, _rect646, _rect647, _rect648, _rect649, _rect650, _rect651, _rect652, _rect653, _rect654, _rect655, _rect656, _rect657, _rect658, _rect659, _rect660, _rect661, _rect662, _rect663, _rect664, _rect665, _rect666, _rect667, _rect668, _rect669, _rect670, _rect671, _rect672, _rect673, _rect674, _rect675, _rect676, _rect677, _rect678, _rect679, _rect680, _rect681, _rect682, _rect683, _rect684, _rect685, _rect686, _rect687, _rect688, _rect689, _rect690, _rect691, _rect692, _rect693, _rect694, _rect695, _rect696, _rect697, _rect698, _rect699, _rect700, _rect701, _rect702, _rect703, _rect704, _rect705, _rect706, _rect707, _rect708, _rect709, _rect710, _rect711, _rect712, _rect713, _rect714, _rect715, _rect716, _rect717, _rect718, _rect719, _rect720, _rect721, _rect722, _rect723, _rect724, _rect725, _rect726, _rect727, _rect728, _rect729, _rect730, _rect731, _rect732, _rect733, _rect734, _rect735, _rect736, _rect737, _rect738, _rect739, _rect740, _rect741, _rect742, _rect743, _rect744, _rect745, _rect746, _rect747, _rect748, _rect749, _rect750, _rect751, _rect752, _rect753, _rect754, _rect755, _rect756, _rect757, _rect758, _rect759, _rect760, _rect761, _rect762, _rect763, _rect764, _rect765, _rect766, _rect767, _rect768, _rect769, _rect770, _rect771, _rect772, _rect773, _rect774, _rect775, _rect776, _rect777, _rect778, _rect779, _rect780, _rect781, _rect782, _rect783, _rect784, _rect785, _rect786, _rect787, _rect788, _rect789, _rect790, _rect791, _rect792, _rect793, _rect794, _rect795, _rect796, _rect797, _rect798, _rect799, _rect800, _rect801, _rect802, _rect803, _rect804, _rect805, _rect806, _rect807, _rect808, _rect809, _rect810, _rect811, _rect812, _rect813, _rect814, _rect815, _rect816, _rect817, _rect818, _rect819, _rect820, _rect821, _rect822, _rect823, _rect824, _rect825, _rect826, _rect827, _rect828, _rect829, _rect830, _rect831, _rect832, _rect833, _rect834, _rect835, _rect836, _rect837, _rect838, _rect839, _rect840, _rect841, _rect842, _rect843, _rect844, _rect845, _rect846, _rect847, _rect848, _rect849, _rect850, _rect851, _rect852, _rect853, _rect854, _rect855, _rect856, _rect857, _rect858, _rect859, _rect860, _rect861, _rect862, _rect863, _rect864, _rect865, _rect866, _rect867, _rect868, _rect869, _rect870, _rect871, _rect872, _rect873, _rect874, _rect875, _rect876, _rect877, _rect878, _rect879, _rect880, _rect881, _rect882, _rect883, _rect884, _rect885, _rect886, _rect887, _rect888, _rect889, _rect890, _rect891, _rect892, _rect893, _rect894, _rect895, _rect896, _rect897, _rect898, _rect899, _rect900, _rect901, _rect902, _rect903, _rect904, _rect905, _rect906, _rect907, _rect908, _rect909, _rect910, _rect911, _rect912, _rect913, _rect914, _rect915, _rect916, _rect917, _rect918, _rect919, _rect920, _rect921, _rect922, _rect923, _rect924, _rect925, _rect926, _rect927, _rect928, _rect929, _rect930, _rect931, _rect932, _rect933, _rect934, _rect935, _rect936, _rect937, _rect938, _rect939, _rect940, _rect941, _rect942, _rect943, _rect944, _rect945, _rect946, _rect947, _rect948, _rect949, _rect950, _rect951, _rect952, _rect953, _rect954, _rect955, _rect956, _rect957, _rect958, _rect959, _rect960, _rect961, _rect962, _rect963, _rect964, _rect965, _rect966, _rect967, _rect968, _rect969, _rect970, _rect971, _rect972, _rect973, _rect974, _rect975, _rect976, _rect977, _rect978, _rect979, _rect980, _rect981, _rect982, _rect983, _rect984, _rect985, _rect986, _rect987, _rect988, _rect989, _rect990, _rect991, _rect992, _rect993, _rect994, _rect995, _rect996, _rect997, _rect998, _rect999, _rect1000, _rect1001, _rect1002, _rect1003, _rect1004, _rect1005, _rect1006, _rect1007, _rect1008, _rect1009, _rect1010, _rect1011, _rect1012, _rect1013, _rect1014, _rect1015, _rect1016, _rect1017, _rect1018, _rect1019, _rect1020, _rect1021, _rect1022, _rect1023, _rect1024, _rect1025, _rect1026, _rect1027, _rect1028, _rect1029, _rect1030, _rect1031, _rect1032, _rect1033, _rect1034, _rect1035, _rect1036, _rect1037, _rect1038, _rect1039, _rect1040, _rect1041, _rect1042, _rect1043, _rect1044, _rect1045, _rect1046, _rect1047, _rect1048, _rect1049, _rect1050, _rect1051, _rect1052, _rect1053, _rect1054, _rect1055, _rect1056, _rect1057, _rect1058, _rect1059, _rect1060, _rect1061, _rect1062, _rect1063, _rect1064, _rect1065, _rect1066, _rect1067, _rect1068, _rect1069, _rect1070, _rect1071, _rect1072, _rect1073, _rect1074, _rect1075, _rect1076, _rect1077, _rect1078, _rect1079, _rect1080, _rect1081, _rect1082, _rect1083, _rect1084, _rect1085, _rect1086, _rect1087, _rect1088, _rect1089, _rect1090, _rect1091, _rect1092, _rect1093, _rect1094, _rect1095, _rect1096, _rect1097, _rect1098, _rect1099, _rect1100, _rect1101, _rect1102, _rect1103, _rect1104, _rect1105, _rect1106, _rect1107, _rect1108, _rect1109, _rect1110, _rect1111, _rect1112, _rect1113, _rect1114, _rect1115, _rect1116, _rect1117, _rect1118, _rect1119, _rect1120, _rect1121, _rect1122, _rect1123, _rect1124, _rect1125, _rect1126, _rect1127, _rect1128, _rect1129, _rect1130, _rect1131, _rect1132, _rect1133, _rect1134, _rect1135, _rect1136, _rect1137, _rect1138, _rect1139, _rect1140, _rect1141, _rect1142, _rect1143, _rect1144, _rect1145, _rect1146, _rect1147, _rect1148, _rect1149, _rect1150, _rect1151, _rect1152, _rect1153, _rect1154, _rect1155, _rect1156, _rect1157, _rect1158, _rect1159, _rect1160, _rect1161, _rect1162, _rect1163, _rect1164, _rect1165, _rect1166, _rect1167, _rect1168, _rect1169, _rect1170, _rect1171, _rect1172, _rect1173, _rect1174, _rect1175, _rect1176, _rect1177, _rect1178, _rect1179, _rect1180, _rect1181, _rect1182, _rect1183, _rect1184, _rect1185, _rect1186, _rect1187, _rect1188, _rect1189, _rect1190, _rect1191, _rect1192, _rect1193, _rect1194, _rect1195, _rect1196, _rect1197, _rect1198, _rect1199, _rect1200, _rect1201, _rect1202, _rect1203, _rect1204, _rect1205, _rect1206, _rect1207, _rect1208, _rect1209, _rect1210, _rect1211, _rect1212, _rect1213, _rect1214, _rect1215, _rect1216, _rect1217, _rect1218, _rect1219, _rect1220, _rect1221, _rect1222, _rect1223, _rect1224, _rect1225, _rect1226, _rect1227, _rect1228, _rect1229, _rect1230, _rect1231, _rect1232, _rect1233, _rect1234, _rect1235, _rect1236, _rect1237, _rect1238, _rect1239, _rect1240, _rect1241, _rect1242, _rect1243, _rect1244, _rect1245, _rect1246, _rect1247, _rect1248, _rect1249, _rect1250, _rect1251, _rect1252, _rect1253, _rect1254, _rect1255, _rect1256, _rect1257, _rect1258, _rect1259, _rect1260, _rect1261, _rect1262, _rect1263, _rect1264, _rect1265, _rect1266, _rect1267, _rect1268, _rect1269, _rect1270, _rect1271, _rect1272, _rect1273, _rect1274, _rect1275, _rect1276, _rect1277, _rect1278, _rect1279, _rect1280, _rect1281, _rect1282, _rect1283, _rect1284, _rect1285, _rect1286, _rect1287, _rect1288, _rect1289, _rect1290, _rect1291, _rect1292, _rect1293, _rect1294, _rect1295, _rect1296, _rect1297, _rect1298, _rect1299, _rect1300, _rect1301, _rect1302, _rect1303, _rect1304, _rect1305, _rect1306, _rect1307, _rect1308, _rect1309, _rect1310, _rect1311, _rect1312;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOnchainLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 71,
    height: 34,
    xmlns: "http://www.w3.org/2000/svg",
    shapeRendering: "crispEdges",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 1,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 1,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 2,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 2,
    width: 1,
    height: 1,
    fill: "#8F974A"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 2,
    width: 1,
    height: 1,
    fill: "#323C39"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 2,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 2,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 2,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 2,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 2,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 2,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 2,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 2,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 2,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 21,
    y: 2,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 22,
    y: 2,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 23,
    y: 2,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 2,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 25,
    y: 2,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 2,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 27,
    y: 2,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 2,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 29,
    y: 2,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 2,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 31,
    y: 2,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 2,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    x: 33,
    y: 2,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    x: 34,
    y: 2,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 2,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 2,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    x: 37,
    y: 2,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    x: 38,
    y: 2,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect31 || (_rect31 = /*#__PURE__*/React.createElement("rect", {
    x: 39,
    y: 2,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect32 || (_rect32 = /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 2,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect33 || (_rect33 = /*#__PURE__*/React.createElement("rect", {
    x: 41,
    y: 2,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect34 || (_rect34 = /*#__PURE__*/React.createElement("rect", {
    x: 42,
    y: 2,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect35 || (_rect35 = /*#__PURE__*/React.createElement("rect", {
    x: 43,
    y: 2,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect36 || (_rect36 = /*#__PURE__*/React.createElement("rect", {
    x: 44,
    y: 2,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect37 || (_rect37 = /*#__PURE__*/React.createElement("rect", {
    x: 45,
    y: 2,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect38 || (_rect38 = /*#__PURE__*/React.createElement("rect", {
    x: 46,
    y: 2,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect39 || (_rect39 = /*#__PURE__*/React.createElement("rect", {
    x: 47,
    y: 2,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect40 || (_rect40 = /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 2,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect41 || (_rect41 = /*#__PURE__*/React.createElement("rect", {
    x: 49,
    y: 2,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect42 || (_rect42 = /*#__PURE__*/React.createElement("rect", {
    x: 50,
    y: 2,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect43 || (_rect43 = /*#__PURE__*/React.createElement("rect", {
    x: 51,
    y: 2,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect44 || (_rect44 = /*#__PURE__*/React.createElement("rect", {
    x: 52,
    y: 2,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect45 || (_rect45 = /*#__PURE__*/React.createElement("rect", {
    x: 53,
    y: 2,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect46 || (_rect46 = /*#__PURE__*/React.createElement("rect", {
    x: 54,
    y: 2,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect47 || (_rect47 = /*#__PURE__*/React.createElement("rect", {
    x: 55,
    y: 2,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect48 || (_rect48 = /*#__PURE__*/React.createElement("rect", {
    x: 56,
    y: 2,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect49 || (_rect49 = /*#__PURE__*/React.createElement("rect", {
    x: 57,
    y: 2,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect50 || (_rect50 = /*#__PURE__*/React.createElement("rect", {
    x: 58,
    y: 2,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect51 || (_rect51 = /*#__PURE__*/React.createElement("rect", {
    x: 59,
    y: 2,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect52 || (_rect52 = /*#__PURE__*/React.createElement("rect", {
    x: 60,
    y: 2,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect53 || (_rect53 = /*#__PURE__*/React.createElement("rect", {
    x: 61,
    y: 2,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect54 || (_rect54 = /*#__PURE__*/React.createElement("rect", {
    x: 62,
    y: 2,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect55 || (_rect55 = /*#__PURE__*/React.createElement("rect", {
    x: 63,
    y: 2,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect56 || (_rect56 = /*#__PURE__*/React.createElement("rect", {
    x: 65,
    y: 2,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect57 || (_rect57 = /*#__PURE__*/React.createElement("rect", {
    x: 66,
    y: 2,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect58 || (_rect58 = /*#__PURE__*/React.createElement("rect", {
    x: 67,
    y: 2,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect59 || (_rect59 = /*#__PURE__*/React.createElement("rect", {
    x: 68,
    y: 2,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect60 || (_rect60 = /*#__PURE__*/React.createElement("rect", {
    x: 69,
    y: 2,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect61 || (_rect61 = /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 3,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect62 || (_rect62 = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 3,
    width: 1,
    height: 1,
    fill: "#8F974A"
  })), _rect63 || (_rect63 = /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 3,
    width: 1,
    height: 1,
    fill: "#323C39"
  })), _rect64 || (_rect64 = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 3,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect65 || (_rect65 = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 3,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect66 || (_rect66 = /*#__PURE__*/React.createElement("rect", {
    x: 21,
    y: 3,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect67 || (_rect67 = /*#__PURE__*/React.createElement("rect", {
    x: 22,
    y: 3,
    width: 1,
    height: 1,
    fill: "#CBDBFC"
  })), _rect68 || (_rect68 = /*#__PURE__*/React.createElement("rect", {
    x: 23,
    y: 3,
    width: 1,
    height: 1,
    fill: "#CBDBFC"
  })), _rect69 || (_rect69 = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 3,
    width: 1,
    height: 1,
    fill: "#CBDBFC"
  })), _rect70 || (_rect70 = /*#__PURE__*/React.createElement("rect", {
    x: 25,
    y: 3,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect71 || (_rect71 = /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 3,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect72 || (_rect72 = /*#__PURE__*/React.createElement("rect", {
    x: 27,
    y: 3,
    width: 1,
    height: 1,
    fill: "#CBDBFC"
  })), _rect73 || (_rect73 = /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 3,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect74 || (_rect74 = /*#__PURE__*/React.createElement("rect", {
    x: 29,
    y: 3,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect75 || (_rect75 = /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 3,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect76 || (_rect76 = /*#__PURE__*/React.createElement("rect", {
    x: 31,
    y: 3,
    width: 1,
    height: 1,
    fill: "#CBDBFC"
  })), _rect77 || (_rect77 = /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 3,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect78 || (_rect78 = /*#__PURE__*/React.createElement("rect", {
    x: 33,
    y: 3,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect79 || (_rect79 = /*#__PURE__*/React.createElement("rect", {
    x: 34,
    y: 3,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect80 || (_rect80 = /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 3,
    width: 1,
    height: 1,
    fill: "#CBDBFC"
  })), _rect81 || (_rect81 = /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 3,
    width: 1,
    height: 1,
    fill: "#CBDBFC"
  })), _rect82 || (_rect82 = /*#__PURE__*/React.createElement("rect", {
    x: 37,
    y: 3,
    width: 1,
    height: 1,
    fill: "#CBDBFC"
  })), _rect83 || (_rect83 = /*#__PURE__*/React.createElement("rect", {
    x: 38,
    y: 3,
    width: 1,
    height: 1,
    fill: "#CBDBFC"
  })), _rect84 || (_rect84 = /*#__PURE__*/React.createElement("rect", {
    x: 39,
    y: 3,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect85 || (_rect85 = /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 3,
    width: 1,
    height: 1,
    fill: "#CBDBFC"
  })), _rect86 || (_rect86 = /*#__PURE__*/React.createElement("rect", {
    x: 41,
    y: 3,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect87 || (_rect87 = /*#__PURE__*/React.createElement("rect", {
    x: 42,
    y: 3,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect88 || (_rect88 = /*#__PURE__*/React.createElement("rect", {
    x: 43,
    y: 3,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect89 || (_rect89 = /*#__PURE__*/React.createElement("rect", {
    x: 44,
    y: 3,
    width: 1,
    height: 1,
    fill: "#CBDBFC"
  })), _rect90 || (_rect90 = /*#__PURE__*/React.createElement("rect", {
    x: 45,
    y: 3,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect91 || (_rect91 = /*#__PURE__*/React.createElement("rect", {
    x: 46,
    y: 3,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect92 || (_rect92 = /*#__PURE__*/React.createElement("rect", {
    x: 47,
    y: 3,
    width: 1,
    height: 1,
    fill: "#CBDBFC"
  })), _rect93 || (_rect93 = /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 3,
    width: 1,
    height: 1,
    fill: "#CBDBFC"
  })), _rect94 || (_rect94 = /*#__PURE__*/React.createElement("rect", {
    x: 49,
    y: 3,
    width: 1,
    height: 1,
    fill: "#CBDBFC"
  })), _rect95 || (_rect95 = /*#__PURE__*/React.createElement("rect", {
    x: 50,
    y: 3,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect96 || (_rect96 = /*#__PURE__*/React.createElement("rect", {
    x: 51,
    y: 3,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect97 || (_rect97 = /*#__PURE__*/React.createElement("rect", {
    x: 52,
    y: 3,
    width: 1,
    height: 1,
    fill: "#CBDBFC"
  })), _rect98 || (_rect98 = /*#__PURE__*/React.createElement("rect", {
    x: 53,
    y: 3,
    width: 1,
    height: 1,
    fill: "#CBDBFC"
  })), _rect99 || (_rect99 = /*#__PURE__*/React.createElement("rect", {
    x: 54,
    y: 3,
    width: 1,
    height: 1,
    fill: "#CBDBFC"
  })), _rect100 || (_rect100 = /*#__PURE__*/React.createElement("rect", {
    x: 55,
    y: 3,
    width: 1,
    height: 1,
    fill: "#CBDBFC"
  })), _rect101 || (_rect101 = /*#__PURE__*/React.createElement("rect", {
    x: 56,
    y: 3,
    width: 1,
    height: 1,
    fill: "#CBDBFC"
  })), _rect102 || (_rect102 = /*#__PURE__*/React.createElement("rect", {
    x: 57,
    y: 3,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect103 || (_rect103 = /*#__PURE__*/React.createElement("rect", {
    x: 58,
    y: 3,
    width: 1,
    height: 1,
    fill: "#CBDBFC"
  })), _rect104 || (_rect104 = /*#__PURE__*/React.createElement("rect", {
    x: 59,
    y: 3,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect105 || (_rect105 = /*#__PURE__*/React.createElement("rect", {
    x: 60,
    y: 3,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect106 || (_rect106 = /*#__PURE__*/React.createElement("rect", {
    x: 61,
    y: 3,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect107 || (_rect107 = /*#__PURE__*/React.createElement("rect", {
    x: 62,
    y: 3,
    width: 1,
    height: 1,
    fill: "#CBDBFC"
  })), _rect108 || (_rect108 = /*#__PURE__*/React.createElement("rect", {
    x: 63,
    y: 3,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect109 || (_rect109 = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 4,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect110 || (_rect110 = /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 4,
    width: 1,
    height: 1,
    fill: "#8F974A"
  })), _rect111 || (_rect111 = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 4,
    width: 1,
    height: 1,
    fill: "#8F974A"
  })), _rect112 || (_rect112 = /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 4,
    width: 1,
    height: 1,
    fill: "#323C39"
  })), _rect113 || (_rect113 = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 4,
    width: 1,
    height: 1,
    fill: "#323C39"
  })), _rect114 || (_rect114 = /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 4,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect115 || (_rect115 = /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 4,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect116 || (_rect116 = /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 4,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect117 || (_rect117 = /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 4,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect118 || (_rect118 = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 4,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect119 || (_rect119 = /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 4,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect120 || (_rect120 = /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 4,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect121 || (_rect121 = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 4,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect122 || (_rect122 = /*#__PURE__*/React.createElement("rect", {
    x: 21,
    y: 4,
    width: 1,
    height: 1,
    fill: "#CBDBFC"
  })), _rect123 || (_rect123 = /*#__PURE__*/React.createElement("rect", {
    x: 22,
    y: 4,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect124 || (_rect124 = /*#__PURE__*/React.createElement("rect", {
    x: 23,
    y: 4,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect125 || (_rect125 = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 4,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect126 || (_rect126 = /*#__PURE__*/React.createElement("rect", {
    x: 25,
    y: 4,
    width: 1,
    height: 1,
    fill: "#CBDBFC"
  })), _rect127 || (_rect127 = /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 4,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect128 || (_rect128 = /*#__PURE__*/React.createElement("rect", {
    x: 27,
    y: 4,
    width: 1,
    height: 1,
    fill: "#CBDBFC"
  })), _rect129 || (_rect129 = /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 4,
    width: 1,
    height: 1,
    fill: "#CBDBFC"
  })), _rect130 || (_rect130 = /*#__PURE__*/React.createElement("rect", {
    x: 29,
    y: 4,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect131 || (_rect131 = /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 4,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect132 || (_rect132 = /*#__PURE__*/React.createElement("rect", {
    x: 31,
    y: 4,
    width: 1,
    height: 1,
    fill: "#CBDBFC"
  })), _rect133 || (_rect133 = /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 4,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect134 || (_rect134 = /*#__PURE__*/React.createElement("rect", {
    x: 33,
    y: 4,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect135 || (_rect135 = /*#__PURE__*/React.createElement("rect", {
    x: 34,
    y: 4,
    width: 1,
    height: 1,
    fill: "#CBDBFC"
  })), _rect136 || (_rect136 = /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 4,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect137 || (_rect137 = /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 4,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect138 || (_rect138 = /*#__PURE__*/React.createElement("rect", {
    x: 37,
    y: 4,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect139 || (_rect139 = /*#__PURE__*/React.createElement("rect", {
    x: 38,
    y: 4,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect140 || (_rect140 = /*#__PURE__*/React.createElement("rect", {
    x: 39,
    y: 4,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect141 || (_rect141 = /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 4,
    width: 1,
    height: 1,
    fill: "#CBDBFC"
  })), _rect142 || (_rect142 = /*#__PURE__*/React.createElement("rect", {
    x: 41,
    y: 4,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect143 || (_rect143 = /*#__PURE__*/React.createElement("rect", {
    x: 42,
    y: 4,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect144 || (_rect144 = /*#__PURE__*/React.createElement("rect", {
    x: 43,
    y: 4,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect145 || (_rect145 = /*#__PURE__*/React.createElement("rect", {
    x: 44,
    y: 4,
    width: 1,
    height: 1,
    fill: "#CBDBFC"
  })), _rect146 || (_rect146 = /*#__PURE__*/React.createElement("rect", {
    x: 45,
    y: 4,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect147 || (_rect147 = /*#__PURE__*/React.createElement("rect", {
    x: 46,
    y: 4,
    width: 1,
    height: 1,
    fill: "#CBDBFC"
  })), _rect148 || (_rect148 = /*#__PURE__*/React.createElement("rect", {
    x: 47,
    y: 4,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect149 || (_rect149 = /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 4,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect150 || (_rect150 = /*#__PURE__*/React.createElement("rect", {
    x: 49,
    y: 4,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect151 || (_rect151 = /*#__PURE__*/React.createElement("rect", {
    x: 50,
    y: 4,
    width: 1,
    height: 1,
    fill: "#CBDBFC"
  })), _rect152 || (_rect152 = /*#__PURE__*/React.createElement("rect", {
    x: 51,
    y: 4,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect153 || (_rect153 = /*#__PURE__*/React.createElement("rect", {
    x: 52,
    y: 4,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect154 || (_rect154 = /*#__PURE__*/React.createElement("rect", {
    x: 53,
    y: 4,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect155 || (_rect155 = /*#__PURE__*/React.createElement("rect", {
    x: 54,
    y: 4,
    width: 1,
    height: 1,
    fill: "#CBDBFC"
  })), _rect156 || (_rect156 = /*#__PURE__*/React.createElement("rect", {
    x: 55,
    y: 4,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect157 || (_rect157 = /*#__PURE__*/React.createElement("rect", {
    x: 56,
    y: 4,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect158 || (_rect158 = /*#__PURE__*/React.createElement("rect", {
    x: 57,
    y: 4,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect159 || (_rect159 = /*#__PURE__*/React.createElement("rect", {
    x: 58,
    y: 4,
    width: 1,
    height: 1,
    fill: "#CBDBFC"
  })), _rect160 || (_rect160 = /*#__PURE__*/React.createElement("rect", {
    x: 59,
    y: 4,
    width: 1,
    height: 1,
    fill: "#CBDBFC"
  })), _rect161 || (_rect161 = /*#__PURE__*/React.createElement("rect", {
    x: 60,
    y: 4,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect162 || (_rect162 = /*#__PURE__*/React.createElement("rect", {
    x: 61,
    y: 4,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect163 || (_rect163 = /*#__PURE__*/React.createElement("rect", {
    x: 62,
    y: 4,
    width: 1,
    height: 1,
    fill: "#CBDBFC"
  })), _rect164 || (_rect164 = /*#__PURE__*/React.createElement("rect", {
    x: 63,
    y: 4,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect165 || (_rect165 = /*#__PURE__*/React.createElement("rect", {
    x: 65,
    y: 4,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect166 || (_rect166 = /*#__PURE__*/React.createElement("rect", {
    x: 66,
    y: 4,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect167 || (_rect167 = /*#__PURE__*/React.createElement("rect", {
    x: 67,
    y: 4,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect168 || (_rect168 = /*#__PURE__*/React.createElement("rect", {
    x: 68,
    y: 4,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect169 || (_rect169 = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 5,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect170 || (_rect170 = /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 5,
    width: 1,
    height: 1,
    fill: "#8F974A"
  })), _rect171 || (_rect171 = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 5,
    width: 1,
    height: 1,
    fill: "#8F974A"
  })), _rect172 || (_rect172 = /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 5,
    width: 1,
    height: 1,
    fill: "#323C39"
  })), _rect173 || (_rect173 = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 5,
    width: 1,
    height: 1,
    fill: "#323C39"
  })), _rect174 || (_rect174 = /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 5,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect175 || (_rect175 = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 5,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect176 || (_rect176 = /*#__PURE__*/React.createElement("rect", {
    x: 21,
    y: 5,
    width: 1,
    height: 1,
    fill: "#CBDBFC"
  })), _rect177 || (_rect177 = /*#__PURE__*/React.createElement("rect", {
    x: 22,
    y: 5,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect178 || (_rect178 = /*#__PURE__*/React.createElement("rect", {
    x: 23,
    y: 5,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect179 || (_rect179 = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 5,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect180 || (_rect180 = /*#__PURE__*/React.createElement("rect", {
    x: 25,
    y: 5,
    width: 1,
    height: 1,
    fill: "#CBDBFC"
  })), _rect181 || (_rect181 = /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 5,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect182 || (_rect182 = /*#__PURE__*/React.createElement("rect", {
    x: 27,
    y: 5,
    width: 1,
    height: 1,
    fill: "#CBDBFC"
  })), _rect183 || (_rect183 = /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 5,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect184 || (_rect184 = /*#__PURE__*/React.createElement("rect", {
    x: 29,
    y: 5,
    width: 1,
    height: 1,
    fill: "#CBDBFC"
  })), _rect185 || (_rect185 = /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 5,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect186 || (_rect186 = /*#__PURE__*/React.createElement("rect", {
    x: 31,
    y: 5,
    width: 1,
    height: 1,
    fill: "#CBDBFC"
  })), _rect187 || (_rect187 = /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 5,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect188 || (_rect188 = /*#__PURE__*/React.createElement("rect", {
    x: 33,
    y: 5,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect189 || (_rect189 = /*#__PURE__*/React.createElement("rect", {
    x: 34,
    y: 5,
    width: 1,
    height: 1,
    fill: "#CBDBFC"
  })), _rect190 || (_rect190 = /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 5,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect191 || (_rect191 = /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 5,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect192 || (_rect192 = /*#__PURE__*/React.createElement("rect", {
    x: 37,
    y: 5,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect193 || (_rect193 = /*#__PURE__*/React.createElement("rect", {
    x: 38,
    y: 5,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect194 || (_rect194 = /*#__PURE__*/React.createElement("rect", {
    x: 39,
    y: 5,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect195 || (_rect195 = /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 5,
    width: 1,
    height: 1,
    fill: "#CBDBFC"
  })), _rect196 || (_rect196 = /*#__PURE__*/React.createElement("rect", {
    x: 41,
    y: 5,
    width: 1,
    height: 1,
    fill: "#CBDBFC"
  })), _rect197 || (_rect197 = /*#__PURE__*/React.createElement("rect", {
    x: 42,
    y: 5,
    width: 1,
    height: 1,
    fill: "#CBDBFC"
  })), _rect198 || (_rect198 = /*#__PURE__*/React.createElement("rect", {
    x: 43,
    y: 5,
    width: 1,
    height: 1,
    fill: "#CBDBFC"
  })), _rect199 || (_rect199 = /*#__PURE__*/React.createElement("rect", {
    x: 44,
    y: 5,
    width: 1,
    height: 1,
    fill: "#CBDBFC"
  })), _rect200 || (_rect200 = /*#__PURE__*/React.createElement("rect", {
    x: 45,
    y: 5,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect201 || (_rect201 = /*#__PURE__*/React.createElement("rect", {
    x: 46,
    y: 5,
    width: 1,
    height: 1,
    fill: "#CBDBFC"
  })), _rect202 || (_rect202 = /*#__PURE__*/React.createElement("rect", {
    x: 47,
    y: 5,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect203 || (_rect203 = /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 5,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect204 || (_rect204 = /*#__PURE__*/React.createElement("rect", {
    x: 49,
    y: 5,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect205 || (_rect205 = /*#__PURE__*/React.createElement("rect", {
    x: 50,
    y: 5,
    width: 1,
    height: 1,
    fill: "#CBDBFC"
  })), _rect206 || (_rect206 = /*#__PURE__*/React.createElement("rect", {
    x: 51,
    y: 5,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect207 || (_rect207 = /*#__PURE__*/React.createElement("rect", {
    x: 52,
    y: 5,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect208 || (_rect208 = /*#__PURE__*/React.createElement("rect", {
    x: 53,
    y: 5,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect209 || (_rect209 = /*#__PURE__*/React.createElement("rect", {
    x: 54,
    y: 5,
    width: 1,
    height: 1,
    fill: "#CBDBFC"
  })), _rect210 || (_rect210 = /*#__PURE__*/React.createElement("rect", {
    x: 55,
    y: 5,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect211 || (_rect211 = /*#__PURE__*/React.createElement("rect", {
    x: 56,
    y: 5,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect212 || (_rect212 = /*#__PURE__*/React.createElement("rect", {
    x: 57,
    y: 5,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect213 || (_rect213 = /*#__PURE__*/React.createElement("rect", {
    x: 58,
    y: 5,
    width: 1,
    height: 1,
    fill: "#CBDBFC"
  })), _rect214 || (_rect214 = /*#__PURE__*/React.createElement("rect", {
    x: 59,
    y: 5,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect215 || (_rect215 = /*#__PURE__*/React.createElement("rect", {
    x: 60,
    y: 5,
    width: 1,
    height: 1,
    fill: "#CBDBFC"
  })), _rect216 || (_rect216 = /*#__PURE__*/React.createElement("rect", {
    x: 61,
    y: 5,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect217 || (_rect217 = /*#__PURE__*/React.createElement("rect", {
    x: 62,
    y: 5,
    width: 1,
    height: 1,
    fill: "#CBDBFC"
  })), _rect218 || (_rect218 = /*#__PURE__*/React.createElement("rect", {
    x: 63,
    y: 5,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect219 || (_rect219 = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 6,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect220 || (_rect220 = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 6,
    width: 1,
    height: 1,
    fill: "#8F974A"
  })), _rect221 || (_rect221 = /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 6,
    width: 1,
    height: 1,
    fill: "#8F974A"
  })), _rect222 || (_rect222 = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 6,
    width: 1,
    height: 1,
    fill: "#8F974A"
  })), _rect223 || (_rect223 = /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 6,
    width: 1,
    height: 1,
    fill: "#323C39"
  })), _rect224 || (_rect224 = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 6,
    width: 1,
    height: 1,
    fill: "#323C39"
  })), _rect225 || (_rect225 = /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 6,
    width: 1,
    height: 1,
    fill: "#323C39"
  })), _rect226 || (_rect226 = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 6,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect227 || (_rect227 = /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 6,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect228 || (_rect228 = /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 6,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect229 || (_rect229 = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 6,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect230 || (_rect230 = /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 6,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect231 || (_rect231 = /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 6,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect232 || (_rect232 = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 6,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect233 || (_rect233 = /*#__PURE__*/React.createElement("rect", {
    x: 21,
    y: 6,
    width: 1,
    height: 1,
    fill: "#CBDBFC"
  })), _rect234 || (_rect234 = /*#__PURE__*/React.createElement("rect", {
    x: 22,
    y: 6,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect235 || (_rect235 = /*#__PURE__*/React.createElement("rect", {
    x: 23,
    y: 6,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect236 || (_rect236 = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 6,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect237 || (_rect237 = /*#__PURE__*/React.createElement("rect", {
    x: 25,
    y: 6,
    width: 1,
    height: 1,
    fill: "#CBDBFC"
  })), _rect238 || (_rect238 = /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 6,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect239 || (_rect239 = /*#__PURE__*/React.createElement("rect", {
    x: 27,
    y: 6,
    width: 1,
    height: 1,
    fill: "#CBDBFC"
  })), _rect240 || (_rect240 = /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 6,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect241 || (_rect241 = /*#__PURE__*/React.createElement("rect", {
    x: 29,
    y: 6,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect242 || (_rect242 = /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 6,
    width: 1,
    height: 1,
    fill: "#CBDBFC"
  })), _rect243 || (_rect243 = /*#__PURE__*/React.createElement("rect", {
    x: 31,
    y: 6,
    width: 1,
    height: 1,
    fill: "#CBDBFC"
  })), _rect244 || (_rect244 = /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 6,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect245 || (_rect245 = /*#__PURE__*/React.createElement("rect", {
    x: 33,
    y: 6,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect246 || (_rect246 = /*#__PURE__*/React.createElement("rect", {
    x: 34,
    y: 6,
    width: 1,
    height: 1,
    fill: "#CBDBFC"
  })), _rect247 || (_rect247 = /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 6,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect248 || (_rect248 = /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 6,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect249 || (_rect249 = /*#__PURE__*/React.createElement("rect", {
    x: 37,
    y: 6,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect250 || (_rect250 = /*#__PURE__*/React.createElement("rect", {
    x: 38,
    y: 6,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect251 || (_rect251 = /*#__PURE__*/React.createElement("rect", {
    x: 39,
    y: 6,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect252 || (_rect252 = /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 6,
    width: 1,
    height: 1,
    fill: "#CBDBFC"
  })), _rect253 || (_rect253 = /*#__PURE__*/React.createElement("rect", {
    x: 41,
    y: 6,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect254 || (_rect254 = /*#__PURE__*/React.createElement("rect", {
    x: 42,
    y: 6,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect255 || (_rect255 = /*#__PURE__*/React.createElement("rect", {
    x: 43,
    y: 6,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect256 || (_rect256 = /*#__PURE__*/React.createElement("rect", {
    x: 44,
    y: 6,
    width: 1,
    height: 1,
    fill: "#CBDBFC"
  })), _rect257 || (_rect257 = /*#__PURE__*/React.createElement("rect", {
    x: 45,
    y: 6,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect258 || (_rect258 = /*#__PURE__*/React.createElement("rect", {
    x: 46,
    y: 6,
    width: 1,
    height: 1,
    fill: "#CBDBFC"
  })), _rect259 || (_rect259 = /*#__PURE__*/React.createElement("rect", {
    x: 47,
    y: 6,
    width: 1,
    height: 1,
    fill: "#CBDBFC"
  })), _rect260 || (_rect260 = /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 6,
    width: 1,
    height: 1,
    fill: "#CBDBFC"
  })), _rect261 || (_rect261 = /*#__PURE__*/React.createElement("rect", {
    x: 49,
    y: 6,
    width: 1,
    height: 1,
    fill: "#CBDBFC"
  })), _rect262 || (_rect262 = /*#__PURE__*/React.createElement("rect", {
    x: 50,
    y: 6,
    width: 1,
    height: 1,
    fill: "#CBDBFC"
  })), _rect263 || (_rect263 = /*#__PURE__*/React.createElement("rect", {
    x: 51,
    y: 6,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect264 || (_rect264 = /*#__PURE__*/React.createElement("rect", {
    x: 52,
    y: 6,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect265 || (_rect265 = /*#__PURE__*/React.createElement("rect", {
    x: 53,
    y: 6,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect266 || (_rect266 = /*#__PURE__*/React.createElement("rect", {
    x: 54,
    y: 6,
    width: 1,
    height: 1,
    fill: "#CBDBFC"
  })), _rect267 || (_rect267 = /*#__PURE__*/React.createElement("rect", {
    x: 55,
    y: 6,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect268 || (_rect268 = /*#__PURE__*/React.createElement("rect", {
    x: 56,
    y: 6,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect269 || (_rect269 = /*#__PURE__*/React.createElement("rect", {
    x: 57,
    y: 6,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect270 || (_rect270 = /*#__PURE__*/React.createElement("rect", {
    x: 58,
    y: 6,
    width: 1,
    height: 1,
    fill: "#CBDBFC"
  })), _rect271 || (_rect271 = /*#__PURE__*/React.createElement("rect", {
    x: 59,
    y: 6,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect272 || (_rect272 = /*#__PURE__*/React.createElement("rect", {
    x: 60,
    y: 6,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect273 || (_rect273 = /*#__PURE__*/React.createElement("rect", {
    x: 61,
    y: 6,
    width: 1,
    height: 1,
    fill: "#CBDBFC"
  })), _rect274 || (_rect274 = /*#__PURE__*/React.createElement("rect", {
    x: 62,
    y: 6,
    width: 1,
    height: 1,
    fill: "#CBDBFC"
  })), _rect275 || (_rect275 = /*#__PURE__*/React.createElement("rect", {
    x: 63,
    y: 6,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect276 || (_rect276 = /*#__PURE__*/React.createElement("rect", {
    x: 65,
    y: 6,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect277 || (_rect277 = /*#__PURE__*/React.createElement("rect", {
    x: 66,
    y: 6,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect278 || (_rect278 = /*#__PURE__*/React.createElement("rect", {
    x: 67,
    y: 6,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect279 || (_rect279 = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 7,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect280 || (_rect280 = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 7,
    width: 1,
    height: 1,
    fill: "#8F974A"
  })), _rect281 || (_rect281 = /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 7,
    width: 1,
    height: 1,
    fill: "#8F974A"
  })), _rect282 || (_rect282 = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 7,
    width: 1,
    height: 1,
    fill: "#8F974A"
  })), _rect283 || (_rect283 = /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 7,
    width: 1,
    height: 1,
    fill: "#323C39"
  })), _rect284 || (_rect284 = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 7,
    width: 1,
    height: 1,
    fill: "#323C39"
  })), _rect285 || (_rect285 = /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 7,
    width: 1,
    height: 1,
    fill: "#323C39"
  })), _rect286 || (_rect286 = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 7,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect287 || (_rect287 = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 7,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect288 || (_rect288 = /*#__PURE__*/React.createElement("rect", {
    x: 21,
    y: 7,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect289 || (_rect289 = /*#__PURE__*/React.createElement("rect", {
    x: 22,
    y: 7,
    width: 1,
    height: 1,
    fill: "#CBDBFC"
  })), _rect290 || (_rect290 = /*#__PURE__*/React.createElement("rect", {
    x: 23,
    y: 7,
    width: 1,
    height: 1,
    fill: "#CBDBFC"
  })), _rect291 || (_rect291 = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 7,
    width: 1,
    height: 1,
    fill: "#CBDBFC"
  })), _rect292 || (_rect292 = /*#__PURE__*/React.createElement("rect", {
    x: 25,
    y: 7,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect293 || (_rect293 = /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 7,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect294 || (_rect294 = /*#__PURE__*/React.createElement("rect", {
    x: 27,
    y: 7,
    width: 1,
    height: 1,
    fill: "#CBDBFC"
  })), _rect295 || (_rect295 = /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 7,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect296 || (_rect296 = /*#__PURE__*/React.createElement("rect", {
    x: 29,
    y: 7,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect297 || (_rect297 = /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 7,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect298 || (_rect298 = /*#__PURE__*/React.createElement("rect", {
    x: 31,
    y: 7,
    width: 1,
    height: 1,
    fill: "#CBDBFC"
  })), _rect299 || (_rect299 = /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 7,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect300 || (_rect300 = /*#__PURE__*/React.createElement("rect", {
    x: 33,
    y: 7,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect301 || (_rect301 = /*#__PURE__*/React.createElement("rect", {
    x: 34,
    y: 7,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect302 || (_rect302 = /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 7,
    width: 1,
    height: 1,
    fill: "#CBDBFC"
  })), _rect303 || (_rect303 = /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 7,
    width: 1,
    height: 1,
    fill: "#CBDBFC"
  })), _rect304 || (_rect304 = /*#__PURE__*/React.createElement("rect", {
    x: 37,
    y: 7,
    width: 1,
    height: 1,
    fill: "#CBDBFC"
  })), _rect305 || (_rect305 = /*#__PURE__*/React.createElement("rect", {
    x: 38,
    y: 7,
    width: 1,
    height: 1,
    fill: "#CBDBFC"
  })), _rect306 || (_rect306 = /*#__PURE__*/React.createElement("rect", {
    x: 39,
    y: 7,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect307 || (_rect307 = /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 7,
    width: 1,
    height: 1,
    fill: "#CBDBFC"
  })), _rect308 || (_rect308 = /*#__PURE__*/React.createElement("rect", {
    x: 41,
    y: 7,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect309 || (_rect309 = /*#__PURE__*/React.createElement("rect", {
    x: 42,
    y: 7,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect310 || (_rect310 = /*#__PURE__*/React.createElement("rect", {
    x: 43,
    y: 7,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect311 || (_rect311 = /*#__PURE__*/React.createElement("rect", {
    x: 44,
    y: 7,
    width: 1,
    height: 1,
    fill: "#CBDBFC"
  })), _rect312 || (_rect312 = /*#__PURE__*/React.createElement("rect", {
    x: 45,
    y: 7,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect313 || (_rect313 = /*#__PURE__*/React.createElement("rect", {
    x: 46,
    y: 7,
    width: 1,
    height: 1,
    fill: "#CBDBFC"
  })), _rect314 || (_rect314 = /*#__PURE__*/React.createElement("rect", {
    x: 47,
    y: 7,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect315 || (_rect315 = /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 7,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect316 || (_rect316 = /*#__PURE__*/React.createElement("rect", {
    x: 49,
    y: 7,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect317 || (_rect317 = /*#__PURE__*/React.createElement("rect", {
    x: 50,
    y: 7,
    width: 1,
    height: 1,
    fill: "#CBDBFC"
  })), _rect318 || (_rect318 = /*#__PURE__*/React.createElement("rect", {
    x: 51,
    y: 7,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect319 || (_rect319 = /*#__PURE__*/React.createElement("rect", {
    x: 52,
    y: 7,
    width: 1,
    height: 1,
    fill: "#CBDBFC"
  })), _rect320 || (_rect320 = /*#__PURE__*/React.createElement("rect", {
    x: 53,
    y: 7,
    width: 1,
    height: 1,
    fill: "#CBDBFC"
  })), _rect321 || (_rect321 = /*#__PURE__*/React.createElement("rect", {
    x: 54,
    y: 7,
    width: 1,
    height: 1,
    fill: "#CBDBFC"
  })), _rect322 || (_rect322 = /*#__PURE__*/React.createElement("rect", {
    x: 55,
    y: 7,
    width: 1,
    height: 1,
    fill: "#CBDBFC"
  })), _rect323 || (_rect323 = /*#__PURE__*/React.createElement("rect", {
    x: 56,
    y: 7,
    width: 1,
    height: 1,
    fill: "#CBDBFC"
  })), _rect324 || (_rect324 = /*#__PURE__*/React.createElement("rect", {
    x: 57,
    y: 7,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect325 || (_rect325 = /*#__PURE__*/React.createElement("rect", {
    x: 58,
    y: 7,
    width: 1,
    height: 1,
    fill: "#CBDBFC"
  })), _rect326 || (_rect326 = /*#__PURE__*/React.createElement("rect", {
    x: 59,
    y: 7,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect327 || (_rect327 = /*#__PURE__*/React.createElement("rect", {
    x: 60,
    y: 7,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect328 || (_rect328 = /*#__PURE__*/React.createElement("rect", {
    x: 61,
    y: 7,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect329 || (_rect329 = /*#__PURE__*/React.createElement("rect", {
    x: 62,
    y: 7,
    width: 1,
    height: 1,
    fill: "#CBDBFC"
  })), _rect330 || (_rect330 = /*#__PURE__*/React.createElement("rect", {
    x: 63,
    y: 7,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect331 || (_rect331 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 8,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect332 || (_rect332 = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 8,
    width: 1,
    height: 1,
    fill: "#8F974A"
  })), _rect333 || (_rect333 = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 8,
    width: 1,
    height: 1,
    fill: "#8F974A"
  })), _rect334 || (_rect334 = /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 8,
    width: 1,
    height: 1,
    fill: "#8F974A"
  })), _rect335 || (_rect335 = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 8,
    width: 1,
    height: 1,
    fill: "#8F974A"
  })), _rect336 || (_rect336 = /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 8,
    width: 1,
    height: 1,
    fill: "#323C39"
  })), _rect337 || (_rect337 = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 8,
    width: 1,
    height: 1,
    fill: "#323C39"
  })), _rect338 || (_rect338 = /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 8,
    width: 1,
    height: 1,
    fill: "#323C39"
  })), _rect339 || (_rect339 = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 8,
    width: 1,
    height: 1,
    fill: "#323C39"
  })), _rect340 || (_rect340 = /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 8,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect341 || (_rect341 = /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 8,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect342 || (_rect342 = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 8,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect343 || (_rect343 = /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 8,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect344 || (_rect344 = /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 8,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect345 || (_rect345 = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 8,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect346 || (_rect346 = /*#__PURE__*/React.createElement("rect", {
    x: 21,
    y: 8,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect347 || (_rect347 = /*#__PURE__*/React.createElement("rect", {
    x: 22,
    y: 8,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect348 || (_rect348 = /*#__PURE__*/React.createElement("rect", {
    x: 23,
    y: 8,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect349 || (_rect349 = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 8,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect350 || (_rect350 = /*#__PURE__*/React.createElement("rect", {
    x: 25,
    y: 8,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect351 || (_rect351 = /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 8,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect352 || (_rect352 = /*#__PURE__*/React.createElement("rect", {
    x: 27,
    y: 8,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect353 || (_rect353 = /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 8,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect354 || (_rect354 = /*#__PURE__*/React.createElement("rect", {
    x: 29,
    y: 8,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect355 || (_rect355 = /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 8,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect356 || (_rect356 = /*#__PURE__*/React.createElement("rect", {
    x: 31,
    y: 8,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect357 || (_rect357 = /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 8,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect358 || (_rect358 = /*#__PURE__*/React.createElement("rect", {
    x: 33,
    y: 8,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect359 || (_rect359 = /*#__PURE__*/React.createElement("rect", {
    x: 34,
    y: 8,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect360 || (_rect360 = /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 8,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect361 || (_rect361 = /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 8,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect362 || (_rect362 = /*#__PURE__*/React.createElement("rect", {
    x: 37,
    y: 8,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect363 || (_rect363 = /*#__PURE__*/React.createElement("rect", {
    x: 38,
    y: 8,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect364 || (_rect364 = /*#__PURE__*/React.createElement("rect", {
    x: 39,
    y: 8,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect365 || (_rect365 = /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 8,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect366 || (_rect366 = /*#__PURE__*/React.createElement("rect", {
    x: 41,
    y: 8,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect367 || (_rect367 = /*#__PURE__*/React.createElement("rect", {
    x: 42,
    y: 8,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect368 || (_rect368 = /*#__PURE__*/React.createElement("rect", {
    x: 43,
    y: 8,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect369 || (_rect369 = /*#__PURE__*/React.createElement("rect", {
    x: 44,
    y: 8,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect370 || (_rect370 = /*#__PURE__*/React.createElement("rect", {
    x: 45,
    y: 8,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect371 || (_rect371 = /*#__PURE__*/React.createElement("rect", {
    x: 46,
    y: 8,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect372 || (_rect372 = /*#__PURE__*/React.createElement("rect", {
    x: 47,
    y: 8,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect373 || (_rect373 = /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 8,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect374 || (_rect374 = /*#__PURE__*/React.createElement("rect", {
    x: 49,
    y: 8,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect375 || (_rect375 = /*#__PURE__*/React.createElement("rect", {
    x: 50,
    y: 8,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect376 || (_rect376 = /*#__PURE__*/React.createElement("rect", {
    x: 51,
    y: 8,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect377 || (_rect377 = /*#__PURE__*/React.createElement("rect", {
    x: 52,
    y: 8,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect378 || (_rect378 = /*#__PURE__*/React.createElement("rect", {
    x: 53,
    y: 8,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect379 || (_rect379 = /*#__PURE__*/React.createElement("rect", {
    x: 54,
    y: 8,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect380 || (_rect380 = /*#__PURE__*/React.createElement("rect", {
    x: 55,
    y: 8,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect381 || (_rect381 = /*#__PURE__*/React.createElement("rect", {
    x: 56,
    y: 8,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect382 || (_rect382 = /*#__PURE__*/React.createElement("rect", {
    x: 57,
    y: 8,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect383 || (_rect383 = /*#__PURE__*/React.createElement("rect", {
    x: 58,
    y: 8,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect384 || (_rect384 = /*#__PURE__*/React.createElement("rect", {
    x: 59,
    y: 8,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect385 || (_rect385 = /*#__PURE__*/React.createElement("rect", {
    x: 60,
    y: 8,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect386 || (_rect386 = /*#__PURE__*/React.createElement("rect", {
    x: 61,
    y: 8,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect387 || (_rect387 = /*#__PURE__*/React.createElement("rect", {
    x: 62,
    y: 8,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect388 || (_rect388 = /*#__PURE__*/React.createElement("rect", {
    x: 63,
    y: 8,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect389 || (_rect389 = /*#__PURE__*/React.createElement("rect", {
    x: 65,
    y: 8,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect390 || (_rect390 = /*#__PURE__*/React.createElement("rect", {
    x: 66,
    y: 8,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect391 || (_rect391 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 9,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect392 || (_rect392 = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 9,
    width: 1,
    height: 1,
    fill: "#8F974A"
  })), _rect393 || (_rect393 = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 9,
    width: 1,
    height: 1,
    fill: "#8F974A"
  })), _rect394 || (_rect394 = /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 9,
    width: 1,
    height: 1,
    fill: "#8F974A"
  })), _rect395 || (_rect395 = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 9,
    width: 1,
    height: 1,
    fill: "#8F974A"
  })), _rect396 || (_rect396 = /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 9,
    width: 1,
    height: 1,
    fill: "#323C39"
  })), _rect397 || (_rect397 = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 9,
    width: 1,
    height: 1,
    fill: "#323C39"
  })), _rect398 || (_rect398 = /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 9,
    width: 1,
    height: 1,
    fill: "#323C39"
  })), _rect399 || (_rect399 = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 9,
    width: 1,
    height: 1,
    fill: "#323C39"
  })), _rect400 || (_rect400 = /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 9,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect401 || (_rect401 = /*#__PURE__*/React.createElement("rect", {
    x: 21,
    y: 9,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect402 || (_rect402 = /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 9,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect403 || (_rect403 = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 10,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect404 || (_rect404 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 10,
    width: 1,
    height: 1,
    fill: "#8F974A"
  })), _rect405 || (_rect405 = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 10,
    width: 1,
    height: 1,
    fill: "#8F974A"
  })), _rect406 || (_rect406 = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 10,
    width: 1,
    height: 1,
    fill: "#8F974A"
  })), _rect407 || (_rect407 = /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 10,
    width: 1,
    height: 1,
    fill: "#8F974A"
  })), _rect408 || (_rect408 = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 10,
    width: 1,
    height: 1,
    fill: "#8F974A"
  })), _rect409 || (_rect409 = /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 10,
    width: 1,
    height: 1,
    fill: "#323C39"
  })), _rect410 || (_rect410 = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 10,
    width: 1,
    height: 1,
    fill: "#323C39"
  })), _rect411 || (_rect411 = /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 10,
    width: 1,
    height: 1,
    fill: "#323C39"
  })), _rect412 || (_rect412 = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 10,
    width: 1,
    height: 1,
    fill: "#323C39"
  })), _rect413 || (_rect413 = /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 10,
    width: 1,
    height: 1,
    fill: "#323C39"
  })), _rect414 || (_rect414 = /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 10,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect415 || (_rect415 = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 10,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect416 || (_rect416 = /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 10,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect417 || (_rect417 = /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 10,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect418 || (_rect418 = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 10,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect419 || (_rect419 = /*#__PURE__*/React.createElement("rect", {
    x: 21,
    y: 10,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect420 || (_rect420 = /*#__PURE__*/React.createElement("rect", {
    x: 22,
    y: 10,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect421 || (_rect421 = /*#__PURE__*/React.createElement("rect", {
    x: 23,
    y: 10,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect422 || (_rect422 = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 10,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect423 || (_rect423 = /*#__PURE__*/React.createElement("rect", {
    x: 25,
    y: 10,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect424 || (_rect424 = /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 10,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect425 || (_rect425 = /*#__PURE__*/React.createElement("rect", {
    x: 27,
    y: 10,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect426 || (_rect426 = /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 10,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect427 || (_rect427 = /*#__PURE__*/React.createElement("rect", {
    x: 29,
    y: 10,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect428 || (_rect428 = /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 10,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect429 || (_rect429 = /*#__PURE__*/React.createElement("rect", {
    x: 31,
    y: 10,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect430 || (_rect430 = /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 10,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect431 || (_rect431 = /*#__PURE__*/React.createElement("rect", {
    x: 33,
    y: 10,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect432 || (_rect432 = /*#__PURE__*/React.createElement("rect", {
    x: 34,
    y: 10,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect433 || (_rect433 = /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 10,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect434 || (_rect434 = /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 10,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect435 || (_rect435 = /*#__PURE__*/React.createElement("rect", {
    x: 38,
    y: 10,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect436 || (_rect436 = /*#__PURE__*/React.createElement("rect", {
    x: 39,
    y: 10,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect437 || (_rect437 = /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 10,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect438 || (_rect438 = /*#__PURE__*/React.createElement("rect", {
    x: 41,
    y: 10,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect439 || (_rect439 = /*#__PURE__*/React.createElement("rect", {
    x: 42,
    y: 10,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect440 || (_rect440 = /*#__PURE__*/React.createElement("rect", {
    x: 44,
    y: 10,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect441 || (_rect441 = /*#__PURE__*/React.createElement("rect", {
    x: 45,
    y: 10,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect442 || (_rect442 = /*#__PURE__*/React.createElement("rect", {
    x: 46,
    y: 10,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect443 || (_rect443 = /*#__PURE__*/React.createElement("rect", {
    x: 47,
    y: 10,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect444 || (_rect444 = /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 10,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect445 || (_rect445 = /*#__PURE__*/React.createElement("rect", {
    x: 49,
    y: 10,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect446 || (_rect446 = /*#__PURE__*/React.createElement("rect", {
    x: 50,
    y: 10,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect447 || (_rect447 = /*#__PURE__*/React.createElement("rect", {
    x: 52,
    y: 10,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect448 || (_rect448 = /*#__PURE__*/React.createElement("rect", {
    x: 53,
    y: 10,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect449 || (_rect449 = /*#__PURE__*/React.createElement("rect", {
    x: 54,
    y: 10,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect450 || (_rect450 = /*#__PURE__*/React.createElement("rect", {
    x: 55,
    y: 10,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect451 || (_rect451 = /*#__PURE__*/React.createElement("rect", {
    x: 56,
    y: 10,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect452 || (_rect452 = /*#__PURE__*/React.createElement("rect", {
    x: 57,
    y: 10,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect453 || (_rect453 = /*#__PURE__*/React.createElement("rect", {
    x: 58,
    y: 10,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect454 || (_rect454 = /*#__PURE__*/React.createElement("rect", {
    x: 59,
    y: 10,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect455 || (_rect455 = /*#__PURE__*/React.createElement("rect", {
    x: 60,
    y: 10,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect456 || (_rect456 = /*#__PURE__*/React.createElement("rect", {
    x: 61,
    y: 10,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect457 || (_rect457 = /*#__PURE__*/React.createElement("rect", {
    x: 63,
    y: 10,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect458 || (_rect458 = /*#__PURE__*/React.createElement("rect", {
    x: 65,
    y: 10,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect459 || (_rect459 = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 11,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect460 || (_rect460 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 11,
    width: 1,
    height: 1,
    fill: "#8F974A"
  })), _rect461 || (_rect461 = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 11,
    width: 1,
    height: 1,
    fill: "#8F974A"
  })), _rect462 || (_rect462 = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 11,
    width: 1,
    height: 1,
    fill: "#8F974A"
  })), _rect463 || (_rect463 = /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 11,
    width: 1,
    height: 1,
    fill: "#8F974A"
  })), _rect464 || (_rect464 = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 11,
    width: 1,
    height: 1,
    fill: "#8F974A"
  })), _rect465 || (_rect465 = /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 11,
    width: 1,
    height: 1,
    fill: "#323C39"
  })), _rect466 || (_rect466 = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 11,
    width: 1,
    height: 1,
    fill: "#323C39"
  })), _rect467 || (_rect467 = /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 11,
    width: 1,
    height: 1,
    fill: "#323C39"
  })), _rect468 || (_rect468 = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 11,
    width: 1,
    height: 1,
    fill: "#323C39"
  })), _rect469 || (_rect469 = /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 11,
    width: 1,
    height: 1,
    fill: "#323C39"
  })), _rect470 || (_rect470 = /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 11,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect471 || (_rect471 = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 11,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect472 || (_rect472 = /*#__PURE__*/React.createElement("rect", {
    x: 21,
    y: 11,
    width: 1,
    height: 1,
    fill: "#CBDBFC"
  })), _rect473 || (_rect473 = /*#__PURE__*/React.createElement("rect", {
    x: 22,
    y: 11,
    width: 1,
    height: 1,
    fill: "#CBDBFC"
  })), _rect474 || (_rect474 = /*#__PURE__*/React.createElement("rect", {
    x: 23,
    y: 11,
    width: 1,
    height: 1,
    fill: "#CBDBFC"
  })), _rect475 || (_rect475 = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 11,
    width: 1,
    height: 1,
    fill: "#CBDBFC"
  })), _rect476 || (_rect476 = /*#__PURE__*/React.createElement("rect", {
    x: 25,
    y: 11,
    width: 1,
    height: 1,
    fill: "#CBDBFC"
  })), _rect477 || (_rect477 = /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 11,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect478 || (_rect478 = /*#__PURE__*/React.createElement("rect", {
    x: 27,
    y: 11,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect479 || (_rect479 = /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 11,
    width: 1,
    height: 1,
    fill: "#CBDBFC"
  })), _rect480 || (_rect480 = /*#__PURE__*/React.createElement("rect", {
    x: 29,
    y: 11,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect481 || (_rect481 = /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 11,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect482 || (_rect482 = /*#__PURE__*/React.createElement("rect", {
    x: 31,
    y: 11,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect483 || (_rect483 = /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 11,
    width: 1,
    height: 1,
    fill: "#CBDBFC"
  })), _rect484 || (_rect484 = /*#__PURE__*/React.createElement("rect", {
    x: 33,
    y: 11,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect485 || (_rect485 = /*#__PURE__*/React.createElement("rect", {
    x: 34,
    y: 11,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect486 || (_rect486 = /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 11,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect487 || (_rect487 = /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 11,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect488 || (_rect488 = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 12,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect489 || (_rect489 = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 12,
    width: 1,
    height: 1,
    fill: "#8F974A"
  })), _rect490 || (_rect490 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 12,
    width: 1,
    height: 1,
    fill: "#8F974A"
  })), _rect491 || (_rect491 = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 12,
    width: 1,
    height: 1,
    fill: "#8F974A"
  })), _rect492 || (_rect492 = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 12,
    width: 1,
    height: 1,
    fill: "#8F974A"
  })), _rect493 || (_rect493 = /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 12,
    width: 1,
    height: 1,
    fill: "#8F974A"
  })), _rect494 || (_rect494 = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 12,
    width: 1,
    height: 1,
    fill: "#8F974A"
  })), _rect495 || (_rect495 = /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 12,
    width: 1,
    height: 1,
    fill: "#323C39"
  })), _rect496 || (_rect496 = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 12,
    width: 1,
    height: 1,
    fill: "#323C39"
  })), _rect497 || (_rect497 = /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 12,
    width: 1,
    height: 1,
    fill: "#323C39"
  })), _rect498 || (_rect498 = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 12,
    width: 1,
    height: 1,
    fill: "#323C39"
  })), _rect499 || (_rect499 = /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 12,
    width: 1,
    height: 1,
    fill: "#323C39"
  })), _rect500 || (_rect500 = /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 12,
    width: 1,
    height: 1,
    fill: "#323C39"
  })), _rect501 || (_rect501 = /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 12,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect502 || (_rect502 = /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 12,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect503 || (_rect503 = /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 12,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect504 || (_rect504 = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 12,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect505 || (_rect505 = /*#__PURE__*/React.createElement("rect", {
    x: 21,
    y: 12,
    width: 1,
    height: 1,
    fill: "#CBDBFC"
  })), _rect506 || (_rect506 = /*#__PURE__*/React.createElement("rect", {
    x: 22,
    y: 12,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect507 || (_rect507 = /*#__PURE__*/React.createElement("rect", {
    x: 23,
    y: 12,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect508 || (_rect508 = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 12,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect509 || (_rect509 = /*#__PURE__*/React.createElement("rect", {
    x: 25,
    y: 12,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect510 || (_rect510 = /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 12,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect511 || (_rect511 = /*#__PURE__*/React.createElement("rect", {
    x: 27,
    y: 12,
    width: 1,
    height: 1,
    fill: "#CBDBFC"
  })), _rect512 || (_rect512 = /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 12,
    width: 1,
    height: 1,
    fill: "#CBDBFC"
  })), _rect513 || (_rect513 = /*#__PURE__*/React.createElement("rect", {
    x: 29,
    y: 12,
    width: 1,
    height: 1,
    fill: "#CBDBFC"
  })), _rect514 || (_rect514 = /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 12,
    width: 1,
    height: 1,
    fill: "#CBDBFC"
  })), _rect515 || (_rect515 = /*#__PURE__*/React.createElement("rect", {
    x: 31,
    y: 12,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect516 || (_rect516 = /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 12,
    width: 1,
    height: 1,
    fill: "#CBDBFC"
  })), _rect517 || (_rect517 = /*#__PURE__*/React.createElement("rect", {
    x: 33,
    y: 12,
    width: 1,
    height: 1,
    fill: "#CBDBFC"
  })), _rect518 || (_rect518 = /*#__PURE__*/React.createElement("rect", {
    x: 34,
    y: 12,
    width: 1,
    height: 1,
    fill: "#CBDBFC"
  })), _rect519 || (_rect519 = /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 12,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect520 || (_rect520 = /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 12,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect521 || (_rect521 = /*#__PURE__*/React.createElement("rect", {
    x: 38,
    y: 12,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect522 || (_rect522 = /*#__PURE__*/React.createElement("rect", {
    x: 39,
    y: 12,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect523 || (_rect523 = /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 12,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect524 || (_rect524 = /*#__PURE__*/React.createElement("rect", {
    x: 41,
    y: 12,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect525 || (_rect525 = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 13,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect526 || (_rect526 = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 13,
    width: 1,
    height: 1,
    fill: "#8F974A"
  })), _rect527 || (_rect527 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 13,
    width: 1,
    height: 1,
    fill: "#8F974A"
  })), _rect528 || (_rect528 = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 13,
    width: 1,
    height: 1,
    fill: "#8F974A"
  })), _rect529 || (_rect529 = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 13,
    width: 1,
    height: 1,
    fill: "#8F974A"
  })), _rect530 || (_rect530 = /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 13,
    width: 1,
    height: 1,
    fill: "#8F974A"
  })), _rect531 || (_rect531 = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 13,
    width: 1,
    height: 1,
    fill: "#323C39"
  })), _rect532 || (_rect532 = /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 13,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect533 || (_rect533 = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 13,
    width: 1,
    height: 1,
    fill: "#323C39"
  })), _rect534 || (_rect534 = /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 13,
    width: 1,
    height: 1,
    fill: "#323C39"
  })), _rect535 || (_rect535 = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 13,
    width: 1,
    height: 1,
    fill: "#323C39"
  })), _rect536 || (_rect536 = /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 13,
    width: 1,
    height: 1,
    fill: "#323C39"
  })), _rect537 || (_rect537 = /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 13,
    width: 1,
    height: 1,
    fill: "#323C39"
  })), _rect538 || (_rect538 = /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 13,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect539 || (_rect539 = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 13,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect540 || (_rect540 = /*#__PURE__*/React.createElement("rect", {
    x: 21,
    y: 13,
    width: 1,
    height: 1,
    fill: "#CBDBFC"
  })), _rect541 || (_rect541 = /*#__PURE__*/React.createElement("rect", {
    x: 22,
    y: 13,
    width: 1,
    height: 1,
    fill: "#CBDBFC"
  })), _rect542 || (_rect542 = /*#__PURE__*/React.createElement("rect", {
    x: 23,
    y: 13,
    width: 1,
    height: 1,
    fill: "#CBDBFC"
  })), _rect543 || (_rect543 = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 13,
    width: 1,
    height: 1,
    fill: "#CBDBFC"
  })), _rect544 || (_rect544 = /*#__PURE__*/React.createElement("rect", {
    x: 25,
    y: 13,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect545 || (_rect545 = /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 13,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect546 || (_rect546 = /*#__PURE__*/React.createElement("rect", {
    x: 27,
    y: 13,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect547 || (_rect547 = /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 13,
    width: 1,
    height: 1,
    fill: "#CBDBFC"
  })), _rect548 || (_rect548 = /*#__PURE__*/React.createElement("rect", {
    x: 29,
    y: 13,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect549 || (_rect549 = /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 13,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect550 || (_rect550 = /*#__PURE__*/React.createElement("rect", {
    x: 31,
    y: 13,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect551 || (_rect551 = /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 13,
    width: 1,
    height: 1,
    fill: "#CBDBFC"
  })), _rect552 || (_rect552 = /*#__PURE__*/React.createElement("rect", {
    x: 33,
    y: 13,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect553 || (_rect553 = /*#__PURE__*/React.createElement("rect", {
    x: 34,
    y: 13,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect554 || (_rect554 = /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 13,
    width: 1,
    height: 1,
    fill: "#CBDBFC"
  })), _rect555 || (_rect555 = /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 13,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect556 || (_rect556 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 14,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect557 || (_rect557 = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 14,
    width: 1,
    height: 1,
    fill: "#8F974A"
  })), _rect558 || (_rect558 = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 14,
    width: 1,
    height: 1,
    fill: "#8F974A"
  })), _rect559 || (_rect559 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 14,
    width: 1,
    height: 1,
    fill: "#8F974A"
  })), _rect560 || (_rect560 = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 14,
    width: 1,
    height: 1,
    fill: "#8F974A"
  })), _rect561 || (_rect561 = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 14,
    width: 1,
    height: 1,
    fill: "#323C39"
  })), _rect562 || (_rect562 = /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 14,
    width: 1,
    height: 1,
    fill: "#323C39"
  })), _rect563 || (_rect563 = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 14,
    width: 1,
    height: 1,
    fill: "#323C39"
  })), _rect564 || (_rect564 = /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 14,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect565 || (_rect565 = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 14,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect566 || (_rect566 = /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 14,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect567 || (_rect567 = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 14,
    width: 1,
    height: 1,
    fill: "#323C39"
  })), _rect568 || (_rect568 = /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 14,
    width: 1,
    height: 1,
    fill: "#323C39"
  })), _rect569 || (_rect569 = /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 14,
    width: 1,
    height: 1,
    fill: "#323C39"
  })), _rect570 || (_rect570 = /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 14,
    width: 1,
    height: 1,
    fill: "#323C39"
  })), _rect571 || (_rect571 = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 14,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect572 || (_rect572 = /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 14,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect573 || (_rect573 = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 14,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect574 || (_rect574 = /*#__PURE__*/React.createElement("rect", {
    x: 21,
    y: 14,
    width: 1,
    height: 1,
    fill: "#CBDBFC"
  })), _rect575 || (_rect575 = /*#__PURE__*/React.createElement("rect", {
    x: 22,
    y: 14,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect576 || (_rect576 = /*#__PURE__*/React.createElement("rect", {
    x: 23,
    y: 14,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect577 || (_rect577 = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 14,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect578 || (_rect578 = /*#__PURE__*/React.createElement("rect", {
    x: 25,
    y: 14,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect579 || (_rect579 = /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 14,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect580 || (_rect580 = /*#__PURE__*/React.createElement("rect", {
    x: 27,
    y: 14,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect581 || (_rect581 = /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 14,
    width: 1,
    height: 1,
    fill: "#CBDBFC"
  })), _rect582 || (_rect582 = /*#__PURE__*/React.createElement("rect", {
    x: 29,
    y: 14,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect583 || (_rect583 = /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 14,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect584 || (_rect584 = /*#__PURE__*/React.createElement("rect", {
    x: 31,
    y: 14,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect585 || (_rect585 = /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 14,
    width: 1,
    height: 1,
    fill: "#CBDBFC"
  })), _rect586 || (_rect586 = /*#__PURE__*/React.createElement("rect", {
    x: 33,
    y: 14,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect587 || (_rect587 = /*#__PURE__*/React.createElement("rect", {
    x: 34,
    y: 14,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect588 || (_rect588 = /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 14,
    width: 1,
    height: 1,
    fill: "#CBDBFC"
  })), _rect589 || (_rect589 = /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 14,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect590 || (_rect590 = /*#__PURE__*/React.createElement("rect", {
    x: 38,
    y: 14,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect591 || (_rect591 = /*#__PURE__*/React.createElement("rect", {
    x: 39,
    y: 14,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect592 || (_rect592 = /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 14,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect593 || (_rect593 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 15,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect594 || (_rect594 = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 15,
    width: 1,
    height: 1,
    fill: "#8F974A"
  })), _rect595 || (_rect595 = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 15,
    width: 1,
    height: 1,
    fill: "#8F974A"
  })), _rect596 || (_rect596 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 15,
    width: 1,
    height: 1,
    fill: "#323C39"
  })), _rect597 || (_rect597 = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 15,
    width: 1,
    height: 1,
    fill: "#323C39"
  })), _rect598 || (_rect598 = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 15,
    width: 1,
    height: 1,
    fill: "#323C39"
  })), _rect599 || (_rect599 = /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 15,
    width: 1,
    height: 1,
    fill: "#323C39"
  })), _rect600 || (_rect600 = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 15,
    width: 1,
    height: 1,
    fill: "#323C39"
  })), _rect601 || (_rect601 = /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 15,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect602 || (_rect602 = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 15,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect603 || (_rect603 = /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 15,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect604 || (_rect604 = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 15,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect605 || (_rect605 = /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 15,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect606 || (_rect606 = /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 15,
    width: 1,
    height: 1,
    fill: "#323C39"
  })), _rect607 || (_rect607 = /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 15,
    width: 1,
    height: 1,
    fill: "#323C39"
  })), _rect608 || (_rect608 = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 15,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect609 || (_rect609 = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 15,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect610 || (_rect610 = /*#__PURE__*/React.createElement("rect", {
    x: 21,
    y: 15,
    width: 1,
    height: 1,
    fill: "#CBDBFC"
  })), _rect611 || (_rect611 = /*#__PURE__*/React.createElement("rect", {
    x: 22,
    y: 15,
    width: 1,
    height: 1,
    fill: "#CBDBFC"
  })), _rect612 || (_rect612 = /*#__PURE__*/React.createElement("rect", {
    x: 23,
    y: 15,
    width: 1,
    height: 1,
    fill: "#CBDBFC"
  })), _rect613 || (_rect613 = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 15,
    width: 1,
    height: 1,
    fill: "#CBDBFC"
  })), _rect614 || (_rect614 = /*#__PURE__*/React.createElement("rect", {
    x: 25,
    y: 15,
    width: 1,
    height: 1,
    fill: "#CBDBFC"
  })), _rect615 || (_rect615 = /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 15,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect616 || (_rect616 = /*#__PURE__*/React.createElement("rect", {
    x: 27,
    y: 15,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect617 || (_rect617 = /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 15,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect618 || (_rect618 = /*#__PURE__*/React.createElement("rect", {
    x: 29,
    y: 15,
    width: 1,
    height: 1,
    fill: "#CBDBFC"
  })), _rect619 || (_rect619 = /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 15,
    width: 1,
    height: 1,
    fill: "#CBDBFC"
  })), _rect620 || (_rect620 = /*#__PURE__*/React.createElement("rect", {
    x: 31,
    y: 15,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect621 || (_rect621 = /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 15,
    width: 1,
    height: 1,
    fill: "#CBDBFC"
  })), _rect622 || (_rect622 = /*#__PURE__*/React.createElement("rect", {
    x: 33,
    y: 15,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect623 || (_rect623 = /*#__PURE__*/React.createElement("rect", {
    x: 34,
    y: 15,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect624 || (_rect624 = /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 15,
    width: 1,
    height: 1,
    fill: "#CBDBFC"
  })), _rect625 || (_rect625 = /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 15,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect626 || (_rect626 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 16,
    width: 1,
    height: 1,
    fill: "#8F974A"
  })), _rect627 || (_rect627 = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 16,
    width: 1,
    height: 1,
    fill: "#323C39"
  })), _rect628 || (_rect628 = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 16,
    width: 1,
    height: 1,
    fill: "#323C39"
  })), _rect629 || (_rect629 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 16,
    width: 1,
    height: 1,
    fill: "#323C39"
  })), _rect630 || (_rect630 = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 16,
    width: 1,
    height: 1,
    fill: "#323C39"
  })), _rect631 || (_rect631 = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 16,
    width: 1,
    height: 1,
    fill: "#323C39"
  })), _rect632 || (_rect632 = /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 16,
    width: 1,
    height: 1,
    fill: "#323C39"
  })), _rect633 || (_rect633 = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 16,
    width: 1,
    height: 1,
    fill: "#323C39"
  })), _rect634 || (_rect634 = /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 16,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect635 || (_rect635 = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 16,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect636 || (_rect636 = /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 16,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect637 || (_rect637 = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 16,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect638 || (_rect638 = /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 16,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect639 || (_rect639 = /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 16,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect640 || (_rect640 = /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 16,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect641 || (_rect641 = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 16,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect642 || (_rect642 = /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 16,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect643 || (_rect643 = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 16,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect644 || (_rect644 = /*#__PURE__*/React.createElement("rect", {
    x: 21,
    y: 16,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect645 || (_rect645 = /*#__PURE__*/React.createElement("rect", {
    x: 22,
    y: 16,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect646 || (_rect646 = /*#__PURE__*/React.createElement("rect", {
    x: 23,
    y: 16,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect647 || (_rect647 = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 16,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect648 || (_rect648 = /*#__PURE__*/React.createElement("rect", {
    x: 25,
    y: 16,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect649 || (_rect649 = /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 16,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect650 || (_rect650 = /*#__PURE__*/React.createElement("rect", {
    x: 27,
    y: 16,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect651 || (_rect651 = /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 16,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect652 || (_rect652 = /*#__PURE__*/React.createElement("rect", {
    x: 29,
    y: 16,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect653 || (_rect653 = /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 16,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect654 || (_rect654 = /*#__PURE__*/React.createElement("rect", {
    x: 31,
    y: 16,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect655 || (_rect655 = /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 16,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect656 || (_rect656 = /*#__PURE__*/React.createElement("rect", {
    x: 33,
    y: 16,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect657 || (_rect657 = /*#__PURE__*/React.createElement("rect", {
    x: 34,
    y: 16,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect658 || (_rect658 = /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 16,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect659 || (_rect659 = /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 16,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect660 || (_rect660 = /*#__PURE__*/React.createElement("rect", {
    x: 38,
    y: 16,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect661 || (_rect661 = /*#__PURE__*/React.createElement("rect", {
    x: 39,
    y: 16,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect662 || (_rect662 = /*#__PURE__*/React.createElement("rect", {
    x: 41,
    y: 16,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect663 || (_rect663 = /*#__PURE__*/React.createElement("rect", {
    x: 42,
    y: 16,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect664 || (_rect664 = /*#__PURE__*/React.createElement("rect", {
    x: 43,
    y: 16,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect665 || (_rect665 = /*#__PURE__*/React.createElement("rect", {
    x: 44,
    y: 16,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect666 || (_rect666 = /*#__PURE__*/React.createElement("rect", {
    x: 46,
    y: 16,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect667 || (_rect667 = /*#__PURE__*/React.createElement("rect", {
    x: 47,
    y: 16,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect668 || (_rect668 = /*#__PURE__*/React.createElement("rect", {
    x: 49,
    y: 16,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect669 || (_rect669 = /*#__PURE__*/React.createElement("rect", {
    x: 50,
    y: 16,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect670 || (_rect670 = /*#__PURE__*/React.createElement("rect", {
    x: 51,
    y: 16,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect671 || (_rect671 = /*#__PURE__*/React.createElement("rect", {
    x: 52,
    y: 16,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect672 || (_rect672 = /*#__PURE__*/React.createElement("rect", {
    x: 53,
    y: 16,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect673 || (_rect673 = /*#__PURE__*/React.createElement("rect", {
    x: 55,
    y: 16,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect674 || (_rect674 = /*#__PURE__*/React.createElement("rect", {
    x: 56,
    y: 16,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect675 || (_rect675 = /*#__PURE__*/React.createElement("rect", {
    x: 57,
    y: 16,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect676 || (_rect676 = /*#__PURE__*/React.createElement("rect", {
    x: 58,
    y: 16,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect677 || (_rect677 = /*#__PURE__*/React.createElement("rect", {
    x: 59,
    y: 16,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect678 || (_rect678 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 17,
    width: 1,
    height: 1,
    fill: "#323C39"
  })), _rect679 || (_rect679 = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 17,
    width: 1,
    height: 1,
    fill: "#323C39"
  })), _rect680 || (_rect680 = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 17,
    width: 1,
    height: 1,
    fill: "#323C39"
  })), _rect681 || (_rect681 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 17,
    width: 1,
    height: 1,
    fill: "#323C39"
  })), _rect682 || (_rect682 = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 17,
    width: 1,
    height: 1,
    fill: "#323C39"
  })), _rect683 || (_rect683 = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 17,
    width: 1,
    height: 1,
    fill: "#323C39"
  })), _rect684 || (_rect684 = /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 17,
    width: 1,
    height: 1,
    fill: "#323C39"
  })), _rect685 || (_rect685 = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 17,
    width: 1,
    height: 1,
    fill: "#323C39"
  })), _rect686 || (_rect686 = /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 17,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect687 || (_rect687 = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 17,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect688 || (_rect688 = /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 17,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect689 || (_rect689 = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 17,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect690 || (_rect690 = /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 17,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect691 || (_rect691 = /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 17,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect692 || (_rect692 = /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 17,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect693 || (_rect693 = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 17,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect694 || (_rect694 = /*#__PURE__*/React.createElement("rect", {
    x: 21,
    y: 17,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect695 || (_rect695 = /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 17,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect696 || (_rect696 = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 18,
    width: 1,
    height: 1,
    fill: "#323C39"
  })), _rect697 || (_rect697 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 18,
    width: 1,
    height: 1,
    fill: "#323C39"
  })), _rect698 || (_rect698 = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 18,
    width: 1,
    height: 1,
    fill: "#323C39"
  })), _rect699 || (_rect699 = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 18,
    width: 1,
    height: 1,
    fill: "#323C39"
  })), _rect700 || (_rect700 = /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 18,
    width: 1,
    height: 1,
    fill: "#323C39"
  })), _rect701 || (_rect701 = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 18,
    width: 1,
    height: 1,
    fill: "#323C39"
  })), _rect702 || (_rect702 = /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 18,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect703 || (_rect703 = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 18,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect704 || (_rect704 = /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 18,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect705 || (_rect705 = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 18,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect706 || (_rect706 = /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 18,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect707 || (_rect707 = /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 18,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect708 || (_rect708 = /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 18,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect709 || (_rect709 = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 18,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect710 || (_rect710 = /*#__PURE__*/React.createElement("rect", {
    x: 21,
    y: 18,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect711 || (_rect711 = /*#__PURE__*/React.createElement("rect", {
    x: 22,
    y: 18,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect712 || (_rect712 = /*#__PURE__*/React.createElement("rect", {
    x: 23,
    y: 18,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect713 || (_rect713 = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 18,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect714 || (_rect714 = /*#__PURE__*/React.createElement("rect", {
    x: 25,
    y: 18,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect715 || (_rect715 = /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 18,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect716 || (_rect716 = /*#__PURE__*/React.createElement("rect", {
    x: 27,
    y: 18,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect717 || (_rect717 = /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 18,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect718 || (_rect718 = /*#__PURE__*/React.createElement("rect", {
    x: 29,
    y: 18,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect719 || (_rect719 = /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 18,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect720 || (_rect720 = /*#__PURE__*/React.createElement("rect", {
    x: 31,
    y: 18,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect721 || (_rect721 = /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 18,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect722 || (_rect722 = /*#__PURE__*/React.createElement("rect", {
    x: 33,
    y: 18,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect723 || (_rect723 = /*#__PURE__*/React.createElement("rect", {
    x: 34,
    y: 18,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect724 || (_rect724 = /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 18,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect725 || (_rect725 = /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 18,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect726 || (_rect726 = /*#__PURE__*/React.createElement("rect", {
    x: 37,
    y: 18,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect727 || (_rect727 = /*#__PURE__*/React.createElement("rect", {
    x: 38,
    y: 18,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect728 || (_rect728 = /*#__PURE__*/React.createElement("rect", {
    x: 39,
    y: 18,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect729 || (_rect729 = /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 18,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect730 || (_rect730 = /*#__PURE__*/React.createElement("rect", {
    x: 41,
    y: 18,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect731 || (_rect731 = /*#__PURE__*/React.createElement("rect", {
    x: 42,
    y: 18,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect732 || (_rect732 = /*#__PURE__*/React.createElement("rect", {
    x: 43,
    y: 18,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect733 || (_rect733 = /*#__PURE__*/React.createElement("rect", {
    x: 44,
    y: 18,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect734 || (_rect734 = /*#__PURE__*/React.createElement("rect", {
    x: 45,
    y: 18,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect735 || (_rect735 = /*#__PURE__*/React.createElement("rect", {
    x: 46,
    y: 18,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect736 || (_rect736 = /*#__PURE__*/React.createElement("rect", {
    x: 47,
    y: 18,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect737 || (_rect737 = /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 18,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect738 || (_rect738 = /*#__PURE__*/React.createElement("rect", {
    x: 49,
    y: 18,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect739 || (_rect739 = /*#__PURE__*/React.createElement("rect", {
    x: 50,
    y: 18,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect740 || (_rect740 = /*#__PURE__*/React.createElement("rect", {
    x: 51,
    y: 18,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect741 || (_rect741 = /*#__PURE__*/React.createElement("rect", {
    x: 52,
    y: 18,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect742 || (_rect742 = /*#__PURE__*/React.createElement("rect", {
    x: 53,
    y: 18,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect743 || (_rect743 = /*#__PURE__*/React.createElement("rect", {
    x: 55,
    y: 18,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect744 || (_rect744 = /*#__PURE__*/React.createElement("rect", {
    x: 56,
    y: 18,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect745 || (_rect745 = /*#__PURE__*/React.createElement("rect", {
    x: 57,
    y: 18,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect746 || (_rect746 = /*#__PURE__*/React.createElement("rect", {
    x: 58,
    y: 18,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect747 || (_rect747 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 19,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect748 || (_rect748 = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 19,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect749 || (_rect749 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 19,
    width: 1,
    height: 1,
    fill: "#323C39"
  })), _rect750 || (_rect750 = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 19,
    width: 1,
    height: 1,
    fill: "#323C39"
  })), _rect751 || (_rect751 = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 19,
    width: 1,
    height: 1,
    fill: "#323C39"
  })), _rect752 || (_rect752 = /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 19,
    width: 1,
    height: 1,
    fill: "#323C39"
  })), _rect753 || (_rect753 = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 19,
    width: 1,
    height: 1,
    fill: "#323C39"
  })), _rect754 || (_rect754 = /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 19,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect755 || (_rect755 = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 19,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect756 || (_rect756 = /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 19,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect757 || (_rect757 = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 19,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect758 || (_rect758 = /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 19,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect759 || (_rect759 = /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 19,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect760 || (_rect760 = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 19,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect761 || (_rect761 = /*#__PURE__*/React.createElement("rect", {
    x: 21,
    y: 19,
    width: 1,
    height: 1,
    fill: "#CBDBFC"
  })), _rect762 || (_rect762 = /*#__PURE__*/React.createElement("rect", {
    x: 22,
    y: 19,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect763 || (_rect763 = /*#__PURE__*/React.createElement("rect", {
    x: 23,
    y: 19,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect764 || (_rect764 = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 19,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect765 || (_rect765 = /*#__PURE__*/React.createElement("rect", {
    x: 25,
    y: 19,
    width: 1,
    height: 1,
    fill: "#CBDBFC"
  })), _rect766 || (_rect766 = /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 19,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect767 || (_rect767 = /*#__PURE__*/React.createElement("rect", {
    x: 27,
    y: 19,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect768 || (_rect768 = /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 19,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect769 || (_rect769 = /*#__PURE__*/React.createElement("rect", {
    x: 29,
    y: 19,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect770 || (_rect770 = /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 19,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect771 || (_rect771 = /*#__PURE__*/React.createElement("rect", {
    x: 31,
    y: 19,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect772 || (_rect772 = /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 19,
    width: 1,
    height: 1,
    fill: "#CBDBFC"
  })), _rect773 || (_rect773 = /*#__PURE__*/React.createElement("rect", {
    x: 33,
    y: 19,
    width: 1,
    height: 1,
    fill: "#CBDBFC"
  })), _rect774 || (_rect774 = /*#__PURE__*/React.createElement("rect", {
    x: 34,
    y: 19,
    width: 1,
    height: 1,
    fill: "#CBDBFC"
  })), _rect775 || (_rect775 = /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 19,
    width: 1,
    height: 1,
    fill: "#CBDBFC"
  })), _rect776 || (_rect776 = /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 19,
    width: 1,
    height: 1,
    fill: "#CBDBFC"
  })), _rect777 || (_rect777 = /*#__PURE__*/React.createElement("rect", {
    x: 37,
    y: 19,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect778 || (_rect778 = /*#__PURE__*/React.createElement("rect", {
    x: 38,
    y: 19,
    width: 1,
    height: 1,
    fill: "#CBDBFC"
  })), _rect779 || (_rect779 = /*#__PURE__*/React.createElement("rect", {
    x: 39,
    y: 19,
    width: 1,
    height: 1,
    fill: "#CBDBFC"
  })), _rect780 || (_rect780 = /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 19,
    width: 1,
    height: 1,
    fill: "#CBDBFC"
  })), _rect781 || (_rect781 = /*#__PURE__*/React.createElement("rect", {
    x: 41,
    y: 19,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect782 || (_rect782 = /*#__PURE__*/React.createElement("rect", {
    x: 42,
    y: 19,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect783 || (_rect783 = /*#__PURE__*/React.createElement("rect", {
    x: 43,
    y: 19,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect784 || (_rect784 = /*#__PURE__*/React.createElement("rect", {
    x: 44,
    y: 19,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect785 || (_rect785 = /*#__PURE__*/React.createElement("rect", {
    x: 45,
    y: 19,
    width: 1,
    height: 1,
    fill: "#CBDBFC"
  })), _rect786 || (_rect786 = /*#__PURE__*/React.createElement("rect", {
    x: 46,
    y: 19,
    width: 1,
    height: 1,
    fill: "#CBDBFC"
  })), _rect787 || (_rect787 = /*#__PURE__*/React.createElement("rect", {
    x: 47,
    y: 19,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect788 || (_rect788 = /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 19,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect789 || (_rect789 = /*#__PURE__*/React.createElement("rect", {
    x: 49,
    y: 19,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect790 || (_rect790 = /*#__PURE__*/React.createElement("rect", {
    x: 50,
    y: 19,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect791 || (_rect791 = /*#__PURE__*/React.createElement("rect", {
    x: 51,
    y: 19,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect792 || (_rect792 = /*#__PURE__*/React.createElement("rect", {
    x: 52,
    y: 19,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect793 || (_rect793 = /*#__PURE__*/React.createElement("rect", {
    x: 53,
    y: 19,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect794 || (_rect794 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 20,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect795 || (_rect795 = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 20,
    width: 1,
    height: 1,
    fill: "#8F974A"
  })), _rect796 || (_rect796 = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 20,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect797 || (_rect797 = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 20,
    width: 1,
    height: 1,
    fill: "#323C39"
  })), _rect798 || (_rect798 = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 20,
    width: 1,
    height: 1,
    fill: "#323C39"
  })), _rect799 || (_rect799 = /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 20,
    width: 1,
    height: 1,
    fill: "#323C39"
  })), _rect800 || (_rect800 = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 20,
    width: 1,
    height: 1,
    fill: "#323C39"
  })), _rect801 || (_rect801 = /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 20,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect802 || (_rect802 = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 20,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect803 || (_rect803 = /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 20,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect804 || (_rect804 = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 20,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect805 || (_rect805 = /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 20,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect806 || (_rect806 = /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 20,
    width: 1,
    height: 1,
    fill: "#323C39"
  })), _rect807 || (_rect807 = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 20,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect808 || (_rect808 = /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 20,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect809 || (_rect809 = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 20,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect810 || (_rect810 = /*#__PURE__*/React.createElement("rect", {
    x: 21,
    y: 20,
    width: 1,
    height: 1,
    fill: "#CBDBFC"
  })), _rect811 || (_rect811 = /*#__PURE__*/React.createElement("rect", {
    x: 22,
    y: 20,
    width: 1,
    height: 1,
    fill: "#CBDBFC"
  })), _rect812 || (_rect812 = /*#__PURE__*/React.createElement("rect", {
    x: 23,
    y: 20,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect813 || (_rect813 = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 20,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect814 || (_rect814 = /*#__PURE__*/React.createElement("rect", {
    x: 25,
    y: 20,
    width: 1,
    height: 1,
    fill: "#CBDBFC"
  })), _rect815 || (_rect815 = /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 20,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect816 || (_rect816 = /*#__PURE__*/React.createElement("rect", {
    x: 27,
    y: 20,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect817 || (_rect817 = /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 20,
    width: 1,
    height: 1,
    fill: "#CBDBFC"
  })), _rect818 || (_rect818 = /*#__PURE__*/React.createElement("rect", {
    x: 29,
    y: 20,
    width: 1,
    height: 1,
    fill: "#CBDBFC"
  })), _rect819 || (_rect819 = /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 20,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect820 || (_rect820 = /*#__PURE__*/React.createElement("rect", {
    x: 31,
    y: 20,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect821 || (_rect821 = /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 20,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect822 || (_rect822 = /*#__PURE__*/React.createElement("rect", {
    x: 33,
    y: 20,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect823 || (_rect823 = /*#__PURE__*/React.createElement("rect", {
    x: 34,
    y: 20,
    width: 1,
    height: 1,
    fill: "#CBDBFC"
  })), _rect824 || (_rect824 = /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 20,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect825 || (_rect825 = /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 20,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect826 || (_rect826 = /*#__PURE__*/React.createElement("rect", {
    x: 37,
    y: 20,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect827 || (_rect827 = /*#__PURE__*/React.createElement("rect", {
    x: 38,
    y: 20,
    width: 1,
    height: 1,
    fill: "#CBDBFC"
  })), _rect828 || (_rect828 = /*#__PURE__*/React.createElement("rect", {
    x: 39,
    y: 20,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect829 || (_rect829 = /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 20,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect830 || (_rect830 = /*#__PURE__*/React.createElement("rect", {
    x: 41,
    y: 20,
    width: 1,
    height: 1,
    fill: "#CBDBFC"
  })), _rect831 || (_rect831 = /*#__PURE__*/React.createElement("rect", {
    x: 42,
    y: 20,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect832 || (_rect832 = /*#__PURE__*/React.createElement("rect", {
    x: 43,
    y: 20,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect833 || (_rect833 = /*#__PURE__*/React.createElement("rect", {
    x: 44,
    y: 20,
    width: 1,
    height: 1,
    fill: "#CBDBFC"
  })), _rect834 || (_rect834 = /*#__PURE__*/React.createElement("rect", {
    x: 45,
    y: 20,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect835 || (_rect835 = /*#__PURE__*/React.createElement("rect", {
    x: 46,
    y: 20,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect836 || (_rect836 = /*#__PURE__*/React.createElement("rect", {
    x: 47,
    y: 20,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect837 || (_rect837 = /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 20,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect838 || (_rect838 = /*#__PURE__*/React.createElement("rect", {
    x: 49,
    y: 20,
    width: 1,
    height: 1,
    fill: "#CBDBFC"
  })), _rect839 || (_rect839 = /*#__PURE__*/React.createElement("rect", {
    x: 50,
    y: 20,
    width: 1,
    height: 1,
    fill: "#CBDBFC"
  })), _rect840 || (_rect840 = /*#__PURE__*/React.createElement("rect", {
    x: 51,
    y: 20,
    width: 1,
    height: 1,
    fill: "#CBDBFC"
  })), _rect841 || (_rect841 = /*#__PURE__*/React.createElement("rect", {
    x: 52,
    y: 20,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect842 || (_rect842 = /*#__PURE__*/React.createElement("rect", {
    x: 53,
    y: 20,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect843 || (_rect843 = /*#__PURE__*/React.createElement("rect", {
    x: 55,
    y: 20,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect844 || (_rect844 = /*#__PURE__*/React.createElement("rect", {
    x: 56,
    y: 20,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect845 || (_rect845 = /*#__PURE__*/React.createElement("rect", {
    x: 57,
    y: 20,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect846 || (_rect846 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 21,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect847 || (_rect847 = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 21,
    width: 1,
    height: 1,
    fill: "#8F974A"
  })), _rect848 || (_rect848 = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 21,
    width: 1,
    height: 1,
    fill: "#8F974A"
  })), _rect849 || (_rect849 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 21,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect850 || (_rect850 = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 21,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect851 || (_rect851 = /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 21,
    width: 1,
    height: 1,
    fill: "#323C39"
  })), _rect852 || (_rect852 = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 21,
    width: 1,
    height: 1,
    fill: "#323C39"
  })), _rect853 || (_rect853 = /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 21,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect854 || (_rect854 = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 21,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect855 || (_rect855 = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 21,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect856 || (_rect856 = /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 21,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect857 || (_rect857 = /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 21,
    width: 1,
    height: 1,
    fill: "#323C39"
  })), _rect858 || (_rect858 = /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 21,
    width: 1,
    height: 1,
    fill: "#323C39"
  })), _rect859 || (_rect859 = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 21,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect860 || (_rect860 = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 21,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect861 || (_rect861 = /*#__PURE__*/React.createElement("rect", {
    x: 21,
    y: 21,
    width: 1,
    height: 1,
    fill: "#CBDBFC"
  })), _rect862 || (_rect862 = /*#__PURE__*/React.createElement("rect", {
    x: 22,
    y: 21,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect863 || (_rect863 = /*#__PURE__*/React.createElement("rect", {
    x: 23,
    y: 21,
    width: 1,
    height: 1,
    fill: "#CBDBFC"
  })), _rect864 || (_rect864 = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 21,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect865 || (_rect865 = /*#__PURE__*/React.createElement("rect", {
    x: 25,
    y: 21,
    width: 1,
    height: 1,
    fill: "#CBDBFC"
  })), _rect866 || (_rect866 = /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 21,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect867 || (_rect867 = /*#__PURE__*/React.createElement("rect", {
    x: 27,
    y: 21,
    width: 1,
    height: 1,
    fill: "#CBDBFC"
  })), _rect868 || (_rect868 = /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 21,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect869 || (_rect869 = /*#__PURE__*/React.createElement("rect", {
    x: 29,
    y: 21,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect870 || (_rect870 = /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 21,
    width: 1,
    height: 1,
    fill: "#CBDBFC"
  })), _rect871 || (_rect871 = /*#__PURE__*/React.createElement("rect", {
    x: 31,
    y: 21,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect872 || (_rect872 = /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 21,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect873 || (_rect873 = /*#__PURE__*/React.createElement("rect", {
    x: 33,
    y: 21,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect874 || (_rect874 = /*#__PURE__*/React.createElement("rect", {
    x: 34,
    y: 21,
    width: 1,
    height: 1,
    fill: "#CBDBFC"
  })), _rect875 || (_rect875 = /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 21,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect876 || (_rect876 = /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 21,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect877 || (_rect877 = /*#__PURE__*/React.createElement("rect", {
    x: 37,
    y: 21,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect878 || (_rect878 = /*#__PURE__*/React.createElement("rect", {
    x: 38,
    y: 21,
    width: 1,
    height: 1,
    fill: "#CBDBFC"
  })), _rect879 || (_rect879 = /*#__PURE__*/React.createElement("rect", {
    x: 39,
    y: 21,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect880 || (_rect880 = /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 21,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect881 || (_rect881 = /*#__PURE__*/React.createElement("rect", {
    x: 41,
    y: 21,
    width: 1,
    height: 1,
    fill: "#CBDBFC"
  })), _rect882 || (_rect882 = /*#__PURE__*/React.createElement("rect", {
    x: 42,
    y: 21,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect883 || (_rect883 = /*#__PURE__*/React.createElement("rect", {
    x: 43,
    y: 21,
    width: 1,
    height: 1,
    fill: "#CBDBFC"
  })), _rect884 || (_rect884 = /*#__PURE__*/React.createElement("rect", {
    x: 44,
    y: 21,
    width: 1,
    height: 1,
    fill: "#CBDBFC"
  })), _rect885 || (_rect885 = /*#__PURE__*/React.createElement("rect", {
    x: 45,
    y: 21,
    width: 1,
    height: 1,
    fill: "#CBDBFC"
  })), _rect886 || (_rect886 = /*#__PURE__*/React.createElement("rect", {
    x: 46,
    y: 21,
    width: 1,
    height: 1,
    fill: "#CBDBFC"
  })), _rect887 || (_rect887 = /*#__PURE__*/React.createElement("rect", {
    x: 47,
    y: 21,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect888 || (_rect888 = /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 21,
    width: 1,
    height: 1,
    fill: "#CBDBFC"
  })), _rect889 || (_rect889 = /*#__PURE__*/React.createElement("rect", {
    x: 49,
    y: 21,
    width: 1,
    height: 1,
    fill: "#CBDBFC"
  })), _rect890 || (_rect890 = /*#__PURE__*/React.createElement("rect", {
    x: 50,
    y: 21,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect891 || (_rect891 = /*#__PURE__*/React.createElement("rect", {
    x: 51,
    y: 21,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect892 || (_rect892 = /*#__PURE__*/React.createElement("rect", {
    x: 52,
    y: 21,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect893 || (_rect893 = /*#__PURE__*/React.createElement("rect", {
    x: 53,
    y: 21,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect894 || (_rect894 = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 22,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect895 || (_rect895 = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 22,
    width: 1,
    height: 1,
    fill: "#8F974A"
  })), _rect896 || (_rect896 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 22,
    width: 1,
    height: 1,
    fill: "#8F974A"
  })), _rect897 || (_rect897 = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 22,
    width: 1,
    height: 1,
    fill: "#8F974A"
  })), _rect898 || (_rect898 = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 22,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect899 || (_rect899 = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 22,
    width: 1,
    height: 1,
    fill: "#323C39"
  })), _rect900 || (_rect900 = /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 22,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect901 || (_rect901 = /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 22,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect902 || (_rect902 = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 22,
    width: 1,
    height: 1,
    fill: "#323C39"
  })), _rect903 || (_rect903 = /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 22,
    width: 1,
    height: 1,
    fill: "#323C39"
  })), _rect904 || (_rect904 = /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 22,
    width: 1,
    height: 1,
    fill: "#323C39"
  })), _rect905 || (_rect905 = /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 22,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect906 || (_rect906 = /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 22,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect907 || (_rect907 = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 22,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect908 || (_rect908 = /*#__PURE__*/React.createElement("rect", {
    x: 21,
    y: 22,
    width: 1,
    height: 1,
    fill: "#CBDBFC"
  })), _rect909 || (_rect909 = /*#__PURE__*/React.createElement("rect", {
    x: 22,
    y: 22,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect910 || (_rect910 = /*#__PURE__*/React.createElement("rect", {
    x: 23,
    y: 22,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect911 || (_rect911 = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 22,
    width: 1,
    height: 1,
    fill: "#CBDBFC"
  })), _rect912 || (_rect912 = /*#__PURE__*/React.createElement("rect", {
    x: 25,
    y: 22,
    width: 1,
    height: 1,
    fill: "#CBDBFC"
  })), _rect913 || (_rect913 = /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 22,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect914 || (_rect914 = /*#__PURE__*/React.createElement("rect", {
    x: 27,
    y: 22,
    width: 1,
    height: 1,
    fill: "#CBDBFC"
  })), _rect915 || (_rect915 = /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 22,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect916 || (_rect916 = /*#__PURE__*/React.createElement("rect", {
    x: 29,
    y: 22,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect917 || (_rect917 = /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 22,
    width: 1,
    height: 1,
    fill: "#CBDBFC"
  })), _rect918 || (_rect918 = /*#__PURE__*/React.createElement("rect", {
    x: 31,
    y: 22,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect919 || (_rect919 = /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 22,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect920 || (_rect920 = /*#__PURE__*/React.createElement("rect", {
    x: 33,
    y: 22,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect921 || (_rect921 = /*#__PURE__*/React.createElement("rect", {
    x: 34,
    y: 22,
    width: 1,
    height: 1,
    fill: "#CBDBFC"
  })), _rect922 || (_rect922 = /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 22,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect923 || (_rect923 = /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 22,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect924 || (_rect924 = /*#__PURE__*/React.createElement("rect", {
    x: 37,
    y: 22,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect925 || (_rect925 = /*#__PURE__*/React.createElement("rect", {
    x: 38,
    y: 22,
    width: 1,
    height: 1,
    fill: "#CBDBFC"
  })), _rect926 || (_rect926 = /*#__PURE__*/React.createElement("rect", {
    x: 39,
    y: 22,
    width: 1,
    height: 1,
    fill: "#CBDBFC"
  })), _rect927 || (_rect927 = /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 22,
    width: 1,
    height: 1,
    fill: "#CBDBFC"
  })), _rect928 || (_rect928 = /*#__PURE__*/React.createElement("rect", {
    x: 41,
    y: 22,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect929 || (_rect929 = /*#__PURE__*/React.createElement("rect", {
    x: 42,
    y: 22,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect930 || (_rect930 = /*#__PURE__*/React.createElement("rect", {
    x: 43,
    y: 22,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect931 || (_rect931 = /*#__PURE__*/React.createElement("rect", {
    x: 44,
    y: 22,
    width: 1,
    height: 1,
    fill: "#CBDBFC"
  })), _rect932 || (_rect932 = /*#__PURE__*/React.createElement("rect", {
    x: 45,
    y: 22,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect933 || (_rect933 = /*#__PURE__*/React.createElement("rect", {
    x: 46,
    y: 22,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect934 || (_rect934 = /*#__PURE__*/React.createElement("rect", {
    x: 47,
    y: 22,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect935 || (_rect935 = /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 22,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect936 || (_rect936 = /*#__PURE__*/React.createElement("rect", {
    x: 49,
    y: 22,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect937 || (_rect937 = /*#__PURE__*/React.createElement("rect", {
    x: 50,
    y: 22,
    width: 1,
    height: 1,
    fill: "#CBDBFC"
  })), _rect938 || (_rect938 = /*#__PURE__*/React.createElement("rect", {
    x: 51,
    y: 22,
    width: 1,
    height: 1,
    fill: "#CBDBFC"
  })), _rect939 || (_rect939 = /*#__PURE__*/React.createElement("rect", {
    x: 52,
    y: 22,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect940 || (_rect940 = /*#__PURE__*/React.createElement("rect", {
    x: 53,
    y: 22,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect941 || (_rect941 = /*#__PURE__*/React.createElement("rect", {
    x: 55,
    y: 22,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect942 || (_rect942 = /*#__PURE__*/React.createElement("rect", {
    x: 56,
    y: 22,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect943 || (_rect943 = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 23,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect944 || (_rect944 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 23,
    width: 1,
    height: 1,
    fill: "#8F974A"
  })), _rect945 || (_rect945 = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 23,
    width: 1,
    height: 1,
    fill: "#8F974A"
  })), _rect946 || (_rect946 = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 23,
    width: 1,
    height: 1,
    fill: "#8F974A"
  })), _rect947 || (_rect947 = /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 23,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect948 || (_rect948 = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 23,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect949 || (_rect949 = /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 23,
    width: 1,
    height: 1,
    fill: "#323C39"
  })), _rect950 || (_rect950 = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 23,
    width: 1,
    height: 1,
    fill: "#323C39"
  })), _rect951 || (_rect951 = /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 23,
    width: 1,
    height: 1,
    fill: "#323C39"
  })), _rect952 || (_rect952 = /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 23,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect953 || (_rect953 = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 23,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect954 || (_rect954 = /*#__PURE__*/React.createElement("rect", {
    x: 21,
    y: 23,
    width: 1,
    height: 1,
    fill: "#CBDBFC"
  })), _rect955 || (_rect955 = /*#__PURE__*/React.createElement("rect", {
    x: 22,
    y: 23,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect956 || (_rect956 = /*#__PURE__*/React.createElement("rect", {
    x: 23,
    y: 23,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect957 || (_rect957 = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 23,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect958 || (_rect958 = /*#__PURE__*/React.createElement("rect", {
    x: 25,
    y: 23,
    width: 1,
    height: 1,
    fill: "#CBDBFC"
  })), _rect959 || (_rect959 = /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 23,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect960 || (_rect960 = /*#__PURE__*/React.createElement("rect", {
    x: 27,
    y: 23,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect961 || (_rect961 = /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 23,
    width: 1,
    height: 1,
    fill: "#CBDBFC"
  })), _rect962 || (_rect962 = /*#__PURE__*/React.createElement("rect", {
    x: 29,
    y: 23,
    width: 1,
    height: 1,
    fill: "#CBDBFC"
  })), _rect963 || (_rect963 = /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 23,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect964 || (_rect964 = /*#__PURE__*/React.createElement("rect", {
    x: 31,
    y: 23,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect965 || (_rect965 = /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 23,
    width: 1,
    height: 1,
    fill: "#CBDBFC"
  })), _rect966 || (_rect966 = /*#__PURE__*/React.createElement("rect", {
    x: 33,
    y: 23,
    width: 1,
    height: 1,
    fill: "#CBDBFC"
  })), _rect967 || (_rect967 = /*#__PURE__*/React.createElement("rect", {
    x: 34,
    y: 23,
    width: 1,
    height: 1,
    fill: "#CBDBFC"
  })), _rect968 || (_rect968 = /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 23,
    width: 1,
    height: 1,
    fill: "#CBDBFC"
  })), _rect969 || (_rect969 = /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 23,
    width: 1,
    height: 1,
    fill: "#CBDBFC"
  })), _rect970 || (_rect970 = /*#__PURE__*/React.createElement("rect", {
    x: 37,
    y: 23,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect971 || (_rect971 = /*#__PURE__*/React.createElement("rect", {
    x: 38,
    y: 23,
    width: 1,
    height: 1,
    fill: "#CBDBFC"
  })), _rect972 || (_rect972 = /*#__PURE__*/React.createElement("rect", {
    x: 39,
    y: 23,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect973 || (_rect973 = /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 23,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect974 || (_rect974 = /*#__PURE__*/React.createElement("rect", {
    x: 41,
    y: 23,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect975 || (_rect975 = /*#__PURE__*/React.createElement("rect", {
    x: 42,
    y: 23,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect976 || (_rect976 = /*#__PURE__*/React.createElement("rect", {
    x: 43,
    y: 23,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect977 || (_rect977 = /*#__PURE__*/React.createElement("rect", {
    x: 44,
    y: 23,
    width: 1,
    height: 1,
    fill: "#CBDBFC"
  })), _rect978 || (_rect978 = /*#__PURE__*/React.createElement("rect", {
    x: 45,
    y: 23,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect979 || (_rect979 = /*#__PURE__*/React.createElement("rect", {
    x: 46,
    y: 23,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect980 || (_rect980 = /*#__PURE__*/React.createElement("rect", {
    x: 47,
    y: 23,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect981 || (_rect981 = /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 23,
    width: 1,
    height: 1,
    fill: "#CBDBFC"
  })), _rect982 || (_rect982 = /*#__PURE__*/React.createElement("rect", {
    x: 49,
    y: 23,
    width: 1,
    height: 1,
    fill: "#CBDBFC"
  })), _rect983 || (_rect983 = /*#__PURE__*/React.createElement("rect", {
    x: 50,
    y: 23,
    width: 1,
    height: 1,
    fill: "#CBDBFC"
  })), _rect984 || (_rect984 = /*#__PURE__*/React.createElement("rect", {
    x: 51,
    y: 23,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect985 || (_rect985 = /*#__PURE__*/React.createElement("rect", {
    x: 52,
    y: 23,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect986 || (_rect986 = /*#__PURE__*/React.createElement("rect", {
    x: 53,
    y: 23,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect987 || (_rect987 = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 24,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect988 || (_rect988 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 24,
    width: 1,
    height: 1,
    fill: "#8F974A"
  })), _rect989 || (_rect989 = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 24,
    width: 1,
    height: 1,
    fill: "#8F974A"
  })), _rect990 || (_rect990 = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 24,
    width: 1,
    height: 1,
    fill: "#8F974A"
  })), _rect991 || (_rect991 = /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 24,
    width: 1,
    height: 1,
    fill: "#8F974A"
  })), _rect992 || (_rect992 = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 24,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect993 || (_rect993 = /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 24,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect994 || (_rect994 = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 24,
    width: 1,
    height: 1,
    fill: "#323C39"
  })), _rect995 || (_rect995 = /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 24,
    width: 1,
    height: 1,
    fill: "#323C39"
  })), _rect996 || (_rect996 = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 24,
    width: 1,
    height: 1,
    fill: "#323C39"
  })), _rect997 || (_rect997 = /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 24,
    width: 1,
    height: 1,
    fill: "#323C39"
  })), _rect998 || (_rect998 = /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 24,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect999 || (_rect999 = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 24,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect1000 || (_rect1000 = /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 24,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect1001 || (_rect1001 = /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 24,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect1002 || (_rect1002 = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 24,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect1003 || (_rect1003 = /*#__PURE__*/React.createElement("rect", {
    x: 21,
    y: 24,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect1004 || (_rect1004 = /*#__PURE__*/React.createElement("rect", {
    x: 22,
    y: 24,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect1005 || (_rect1005 = /*#__PURE__*/React.createElement("rect", {
    x: 23,
    y: 24,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect1006 || (_rect1006 = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 24,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect1007 || (_rect1007 = /*#__PURE__*/React.createElement("rect", {
    x: 25,
    y: 24,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect1008 || (_rect1008 = /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 24,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect1009 || (_rect1009 = /*#__PURE__*/React.createElement("rect", {
    x: 27,
    y: 24,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect1010 || (_rect1010 = /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 24,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect1011 || (_rect1011 = /*#__PURE__*/React.createElement("rect", {
    x: 29,
    y: 24,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect1012 || (_rect1012 = /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 24,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect1013 || (_rect1013 = /*#__PURE__*/React.createElement("rect", {
    x: 31,
    y: 24,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect1014 || (_rect1014 = /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 24,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect1015 || (_rect1015 = /*#__PURE__*/React.createElement("rect", {
    x: 33,
    y: 24,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect1016 || (_rect1016 = /*#__PURE__*/React.createElement("rect", {
    x: 34,
    y: 24,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect1017 || (_rect1017 = /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 24,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect1018 || (_rect1018 = /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 24,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect1019 || (_rect1019 = /*#__PURE__*/React.createElement("rect", {
    x: 37,
    y: 24,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect1020 || (_rect1020 = /*#__PURE__*/React.createElement("rect", {
    x: 38,
    y: 24,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect1021 || (_rect1021 = /*#__PURE__*/React.createElement("rect", {
    x: 39,
    y: 24,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect1022 || (_rect1022 = /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 24,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect1023 || (_rect1023 = /*#__PURE__*/React.createElement("rect", {
    x: 41,
    y: 24,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect1024 || (_rect1024 = /*#__PURE__*/React.createElement("rect", {
    x: 42,
    y: 24,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect1025 || (_rect1025 = /*#__PURE__*/React.createElement("rect", {
    x: 43,
    y: 24,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect1026 || (_rect1026 = /*#__PURE__*/React.createElement("rect", {
    x: 44,
    y: 24,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect1027 || (_rect1027 = /*#__PURE__*/React.createElement("rect", {
    x: 45,
    y: 24,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect1028 || (_rect1028 = /*#__PURE__*/React.createElement("rect", {
    x: 46,
    y: 24,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect1029 || (_rect1029 = /*#__PURE__*/React.createElement("rect", {
    x: 47,
    y: 24,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect1030 || (_rect1030 = /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 24,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect1031 || (_rect1031 = /*#__PURE__*/React.createElement("rect", {
    x: 49,
    y: 24,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect1032 || (_rect1032 = /*#__PURE__*/React.createElement("rect", {
    x: 50,
    y: 24,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect1033 || (_rect1033 = /*#__PURE__*/React.createElement("rect", {
    x: 51,
    y: 24,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect1034 || (_rect1034 = /*#__PURE__*/React.createElement("rect", {
    x: 52,
    y: 24,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect1035 || (_rect1035 = /*#__PURE__*/React.createElement("rect", {
    x: 53,
    y: 24,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect1036 || (_rect1036 = /*#__PURE__*/React.createElement("rect", {
    x: 55,
    y: 24,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect1037 || (_rect1037 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 25,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect1038 || (_rect1038 = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 25,
    width: 1,
    height: 1,
    fill: "#8F974A"
  })), _rect1039 || (_rect1039 = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 25,
    width: 1,
    height: 1,
    fill: "#8F974A"
  })), _rect1040 || (_rect1040 = /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 25,
    width: 1,
    height: 1,
    fill: "#8F974A"
  })), _rect1041 || (_rect1041 = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 25,
    width: 1,
    height: 1,
    fill: "#8F974A"
  })), _rect1042 || (_rect1042 = /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 25,
    width: 1,
    height: 1,
    fill: "#323C39"
  })), _rect1043 || (_rect1043 = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 25,
    width: 1,
    height: 1,
    fill: "#323C39"
  })), _rect1044 || (_rect1044 = /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 25,
    width: 1,
    height: 1,
    fill: "#323C39"
  })), _rect1045 || (_rect1045 = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 25,
    width: 1,
    height: 1,
    fill: "#323C39"
  })), _rect1046 || (_rect1046 = /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 25,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect1047 || (_rect1047 = /*#__PURE__*/React.createElement("rect", {
    x: 21,
    y: 25,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect1048 || (_rect1048 = /*#__PURE__*/React.createElement("rect", {
    x: 44,
    y: 25,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect1049 || (_rect1049 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 26,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect1050 || (_rect1050 = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 26,
    width: 1,
    height: 1,
    fill: "#8F974A"
  })), _rect1051 || (_rect1051 = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 26,
    width: 1,
    height: 1,
    fill: "#8F974A"
  })), _rect1052 || (_rect1052 = /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 26,
    width: 1,
    height: 1,
    fill: "#8F974A"
  })), _rect1053 || (_rect1053 = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 26,
    width: 1,
    height: 1,
    fill: "#8F974A"
  })), _rect1054 || (_rect1054 = /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 26,
    width: 1,
    height: 1,
    fill: "#323C39"
  })), _rect1055 || (_rect1055 = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 26,
    width: 1,
    height: 1,
    fill: "#323C39"
  })), _rect1056 || (_rect1056 = /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 26,
    width: 1,
    height: 1,
    fill: "#323C39"
  })), _rect1057 || (_rect1057 = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 26,
    width: 1,
    height: 1,
    fill: "#323C39"
  })), _rect1058 || (_rect1058 = /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 26,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect1059 || (_rect1059 = /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 26,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect1060 || (_rect1060 = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 26,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect1061 || (_rect1061 = /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 26,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect1062 || (_rect1062 = /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 26,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect1063 || (_rect1063 = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 26,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect1064 || (_rect1064 = /*#__PURE__*/React.createElement("rect", {
    x: 21,
    y: 26,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect1065 || (_rect1065 = /*#__PURE__*/React.createElement("rect", {
    x: 22,
    y: 26,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect1066 || (_rect1066 = /*#__PURE__*/React.createElement("rect", {
    x: 23,
    y: 26,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect1067 || (_rect1067 = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 26,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect1068 || (_rect1068 = /*#__PURE__*/React.createElement("rect", {
    x: 25,
    y: 26,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect1069 || (_rect1069 = /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 26,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect1070 || (_rect1070 = /*#__PURE__*/React.createElement("rect", {
    x: 27,
    y: 26,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect1071 || (_rect1071 = /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 26,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect1072 || (_rect1072 = /*#__PURE__*/React.createElement("rect", {
    x: 29,
    y: 26,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect1073 || (_rect1073 = /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 26,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect1074 || (_rect1074 = /*#__PURE__*/React.createElement("rect", {
    x: 31,
    y: 26,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect1075 || (_rect1075 = /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 26,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect1076 || (_rect1076 = /*#__PURE__*/React.createElement("rect", {
    x: 33,
    y: 26,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect1077 || (_rect1077 = /*#__PURE__*/React.createElement("rect", {
    x: 34,
    y: 26,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect1078 || (_rect1078 = /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 26,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect1079 || (_rect1079 = /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 26,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect1080 || (_rect1080 = /*#__PURE__*/React.createElement("rect", {
    x: 37,
    y: 26,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect1081 || (_rect1081 = /*#__PURE__*/React.createElement("rect", {
    x: 38,
    y: 26,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect1082 || (_rect1082 = /*#__PURE__*/React.createElement("rect", {
    x: 39,
    y: 26,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect1083 || (_rect1083 = /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 26,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect1084 || (_rect1084 = /*#__PURE__*/React.createElement("rect", {
    x: 41,
    y: 26,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect1085 || (_rect1085 = /*#__PURE__*/React.createElement("rect", {
    x: 42,
    y: 26,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect1086 || (_rect1086 = /*#__PURE__*/React.createElement("rect", {
    x: 43,
    y: 26,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect1087 || (_rect1087 = /*#__PURE__*/React.createElement("rect", {
    x: 44,
    y: 26,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect1088 || (_rect1088 = /*#__PURE__*/React.createElement("rect", {
    x: 45,
    y: 26,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect1089 || (_rect1089 = /*#__PURE__*/React.createElement("rect", {
    x: 47,
    y: 26,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect1090 || (_rect1090 = /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 26,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect1091 || (_rect1091 = /*#__PURE__*/React.createElement("rect", {
    x: 49,
    y: 26,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect1092 || (_rect1092 = /*#__PURE__*/React.createElement("rect", {
    x: 50,
    y: 26,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect1093 || (_rect1093 = /*#__PURE__*/React.createElement("rect", {
    x: 51,
    y: 26,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect1094 || (_rect1094 = /*#__PURE__*/React.createElement("rect", {
    x: 52,
    y: 26,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect1095 || (_rect1095 = /*#__PURE__*/React.createElement("rect", {
    x: 53,
    y: 26,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect1096 || (_rect1096 = /*#__PURE__*/React.createElement("rect", {
    x: 54,
    y: 26,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect1097 || (_rect1097 = /*#__PURE__*/React.createElement("rect", {
    x: 55,
    y: 26,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect1098 || (_rect1098 = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 27,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect1099 || (_rect1099 = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 27,
    width: 1,
    height: 1,
    fill: "#8F974A"
  })), _rect1100 || (_rect1100 = /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 27,
    width: 1,
    height: 1,
    fill: "#8F974A"
  })), _rect1101 || (_rect1101 = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 27,
    width: 1,
    height: 1,
    fill: "#8F974A"
  })), _rect1102 || (_rect1102 = /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 27,
    width: 1,
    height: 1,
    fill: "#323C39"
  })), _rect1103 || (_rect1103 = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 27,
    width: 1,
    height: 1,
    fill: "#323C39"
  })), _rect1104 || (_rect1104 = /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 27,
    width: 1,
    height: 1,
    fill: "#323C39"
  })), _rect1105 || (_rect1105 = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 27,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect1106 || (_rect1106 = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 27,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect1107 || (_rect1107 = /*#__PURE__*/React.createElement("rect", {
    x: 21,
    y: 27,
    width: 1,
    height: 1,
    fill: "#CBDBFC"
  })), _rect1108 || (_rect1108 = /*#__PURE__*/React.createElement("rect", {
    x: 22,
    y: 27,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect1109 || (_rect1109 = /*#__PURE__*/React.createElement("rect", {
    x: 23,
    y: 27,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect1110 || (_rect1110 = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 27,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect1111 || (_rect1111 = /*#__PURE__*/React.createElement("rect", {
    x: 25,
    y: 27,
    width: 1,
    height: 1,
    fill: "#CBDBFC"
  })), _rect1112 || (_rect1112 = /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 27,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect1113 || (_rect1113 = /*#__PURE__*/React.createElement("rect", {
    x: 27,
    y: 27,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect1114 || (_rect1114 = /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 27,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect1115 || (_rect1115 = /*#__PURE__*/React.createElement("rect", {
    x: 29,
    y: 27,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect1116 || (_rect1116 = /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 27,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect1117 || (_rect1117 = /*#__PURE__*/React.createElement("rect", {
    x: 31,
    y: 27,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect1118 || (_rect1118 = /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 27,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect1119 || (_rect1119 = /*#__PURE__*/React.createElement("rect", {
    x: 33,
    y: 27,
    width: 1,
    height: 1,
    fill: "#CBDBFC"
  })), _rect1120 || (_rect1120 = /*#__PURE__*/React.createElement("rect", {
    x: 34,
    y: 27,
    width: 1,
    height: 1,
    fill: "#CBDBFC"
  })), _rect1121 || (_rect1121 = /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 27,
    width: 1,
    height: 1,
    fill: "#CBDBFC"
  })), _rect1122 || (_rect1122 = /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 27,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect1123 || (_rect1123 = /*#__PURE__*/React.createElement("rect", {
    x: 37,
    y: 27,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect1124 || (_rect1124 = /*#__PURE__*/React.createElement("rect", {
    x: 38,
    y: 27,
    width: 1,
    height: 1,
    fill: "#CBDBFC"
  })), _rect1125 || (_rect1125 = /*#__PURE__*/React.createElement("rect", {
    x: 39,
    y: 27,
    width: 1,
    height: 1,
    fill: "#CBDBFC"
  })), _rect1126 || (_rect1126 = /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 27,
    width: 1,
    height: 1,
    fill: "#CBDBFC"
  })), _rect1127 || (_rect1127 = /*#__PURE__*/React.createElement("rect", {
    x: 41,
    y: 27,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect1128 || (_rect1128 = /*#__PURE__*/React.createElement("rect", {
    x: 42,
    y: 27,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect1129 || (_rect1129 = /*#__PURE__*/React.createElement("rect", {
    x: 43,
    y: 27,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect1130 || (_rect1130 = /*#__PURE__*/React.createElement("rect", {
    x: 44,
    y: 27,
    width: 1,
    height: 1,
    fill: "#CBDBFC"
  })), _rect1131 || (_rect1131 = /*#__PURE__*/React.createElement("rect", {
    x: 45,
    y: 27,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect1132 || (_rect1132 = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 28,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect1133 || (_rect1133 = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 28,
    width: 1,
    height: 1,
    fill: "#8F974A"
  })), _rect1134 || (_rect1134 = /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 28,
    width: 1,
    height: 1,
    fill: "#8F974A"
  })), _rect1135 || (_rect1135 = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 28,
    width: 1,
    height: 1,
    fill: "#8F974A"
  })), _rect1136 || (_rect1136 = /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 28,
    width: 1,
    height: 1,
    fill: "#323C39"
  })), _rect1137 || (_rect1137 = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 28,
    width: 1,
    height: 1,
    fill: "#323C39"
  })), _rect1138 || (_rect1138 = /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 28,
    width: 1,
    height: 1,
    fill: "#323C39"
  })), _rect1139 || (_rect1139 = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 28,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect1140 || (_rect1140 = /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 28,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect1141 || (_rect1141 = /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 28,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect1142 || (_rect1142 = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 28,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect1143 || (_rect1143 = /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 28,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect1144 || (_rect1144 = /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 28,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect1145 || (_rect1145 = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 28,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect1146 || (_rect1146 = /*#__PURE__*/React.createElement("rect", {
    x: 21,
    y: 28,
    width: 1,
    height: 1,
    fill: "#CBDBFC"
  })), _rect1147 || (_rect1147 = /*#__PURE__*/React.createElement("rect", {
    x: 22,
    y: 28,
    width: 1,
    height: 1,
    fill: "#CBDBFC"
  })), _rect1148 || (_rect1148 = /*#__PURE__*/React.createElement("rect", {
    x: 23,
    y: 28,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect1149 || (_rect1149 = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 28,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect1150 || (_rect1150 = /*#__PURE__*/React.createElement("rect", {
    x: 25,
    y: 28,
    width: 1,
    height: 1,
    fill: "#CBDBFC"
  })), _rect1151 || (_rect1151 = /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 28,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect1152 || (_rect1152 = /*#__PURE__*/React.createElement("rect", {
    x: 27,
    y: 28,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect1153 || (_rect1153 = /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 28,
    width: 1,
    height: 1,
    fill: "#CBDBFC"
  })), _rect1154 || (_rect1154 = /*#__PURE__*/React.createElement("rect", {
    x: 29,
    y: 28,
    width: 1,
    height: 1,
    fill: "#CBDBFC"
  })), _rect1155 || (_rect1155 = /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 28,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect1156 || (_rect1156 = /*#__PURE__*/React.createElement("rect", {
    x: 31,
    y: 28,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect1157 || (_rect1157 = /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 28,
    width: 1,
    height: 1,
    fill: "#CBDBFC"
  })), _rect1158 || (_rect1158 = /*#__PURE__*/React.createElement("rect", {
    x: 33,
    y: 28,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect1159 || (_rect1159 = /*#__PURE__*/React.createElement("rect", {
    x: 34,
    y: 28,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect1160 || (_rect1160 = /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 28,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect1161 || (_rect1161 = /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 28,
    width: 1,
    height: 1,
    fill: "#CBDBFC"
  })), _rect1162 || (_rect1162 = /*#__PURE__*/React.createElement("rect", {
    x: 37,
    y: 28,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect1163 || (_rect1163 = /*#__PURE__*/React.createElement("rect", {
    x: 38,
    y: 28,
    width: 1,
    height: 1,
    fill: "#CBDBFC"
  })), _rect1164 || (_rect1164 = /*#__PURE__*/React.createElement("rect", {
    x: 39,
    y: 28,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect1165 || (_rect1165 = /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 28,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect1166 || (_rect1166 = /*#__PURE__*/React.createElement("rect", {
    x: 41,
    y: 28,
    width: 1,
    height: 1,
    fill: "#CBDBFC"
  })), _rect1167 || (_rect1167 = /*#__PURE__*/React.createElement("rect", {
    x: 42,
    y: 28,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect1168 || (_rect1168 = /*#__PURE__*/React.createElement("rect", {
    x: 43,
    y: 28,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect1169 || (_rect1169 = /*#__PURE__*/React.createElement("rect", {
    x: 44,
    y: 28,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect1170 || (_rect1170 = /*#__PURE__*/React.createElement("rect", {
    x: 45,
    y: 28,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect1171 || (_rect1171 = /*#__PURE__*/React.createElement("rect", {
    x: 47,
    y: 28,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect1172 || (_rect1172 = /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 28,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect1173 || (_rect1173 = /*#__PURE__*/React.createElement("rect", {
    x: 49,
    y: 28,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect1174 || (_rect1174 = /*#__PURE__*/React.createElement("rect", {
    x: 50,
    y: 28,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect1175 || (_rect1175 = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 29,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect1176 || (_rect1176 = /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 29,
    width: 1,
    height: 1,
    fill: "#8F974A"
  })), _rect1177 || (_rect1177 = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 29,
    width: 1,
    height: 1,
    fill: "#8F974A"
  })), _rect1178 || (_rect1178 = /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 29,
    width: 1,
    height: 1,
    fill: "#323C39"
  })), _rect1179 || (_rect1179 = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 29,
    width: 1,
    height: 1,
    fill: "#323C39"
  })), _rect1180 || (_rect1180 = /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 29,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect1181 || (_rect1181 = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 29,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect1182 || (_rect1182 = /*#__PURE__*/React.createElement("rect", {
    x: 21,
    y: 29,
    width: 1,
    height: 1,
    fill: "#CBDBFC"
  })), _rect1183 || (_rect1183 = /*#__PURE__*/React.createElement("rect", {
    x: 22,
    y: 29,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect1184 || (_rect1184 = /*#__PURE__*/React.createElement("rect", {
    x: 23,
    y: 29,
    width: 1,
    height: 1,
    fill: "#CBDBFC"
  })), _rect1185 || (_rect1185 = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 29,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect1186 || (_rect1186 = /*#__PURE__*/React.createElement("rect", {
    x: 25,
    y: 29,
    width: 1,
    height: 1,
    fill: "#CBDBFC"
  })), _rect1187 || (_rect1187 = /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 29,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect1188 || (_rect1188 = /*#__PURE__*/React.createElement("rect", {
    x: 27,
    y: 29,
    width: 1,
    height: 1,
    fill: "#CBDBFC"
  })), _rect1189 || (_rect1189 = /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 29,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect1190 || (_rect1190 = /*#__PURE__*/React.createElement("rect", {
    x: 29,
    y: 29,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect1191 || (_rect1191 = /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 29,
    width: 1,
    height: 1,
    fill: "#CBDBFC"
  })), _rect1192 || (_rect1192 = /*#__PURE__*/React.createElement("rect", {
    x: 31,
    y: 29,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect1193 || (_rect1193 = /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 29,
    width: 1,
    height: 1,
    fill: "#CBDBFC"
  })), _rect1194 || (_rect1194 = /*#__PURE__*/React.createElement("rect", {
    x: 33,
    y: 29,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect1195 || (_rect1195 = /*#__PURE__*/React.createElement("rect", {
    x: 34,
    y: 29,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect1196 || (_rect1196 = /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 29,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect1197 || (_rect1197 = /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 29,
    width: 1,
    height: 1,
    fill: "#CBDBFC"
  })), _rect1198 || (_rect1198 = /*#__PURE__*/React.createElement("rect", {
    x: 37,
    y: 29,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect1199 || (_rect1199 = /*#__PURE__*/React.createElement("rect", {
    x: 38,
    y: 29,
    width: 1,
    height: 1,
    fill: "#CBDBFC"
  })), _rect1200 || (_rect1200 = /*#__PURE__*/React.createElement("rect", {
    x: 39,
    y: 29,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect1201 || (_rect1201 = /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 29,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect1202 || (_rect1202 = /*#__PURE__*/React.createElement("rect", {
    x: 41,
    y: 29,
    width: 1,
    height: 1,
    fill: "#CBDBFC"
  })), _rect1203 || (_rect1203 = /*#__PURE__*/React.createElement("rect", {
    x: 42,
    y: 29,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect1204 || (_rect1204 = /*#__PURE__*/React.createElement("rect", {
    x: 43,
    y: 29,
    width: 1,
    height: 1,
    fill: "#CBDBFC"
  })), _rect1205 || (_rect1205 = /*#__PURE__*/React.createElement("rect", {
    x: 44,
    y: 29,
    width: 1,
    height: 1,
    fill: "#CBDBFC"
  })), _rect1206 || (_rect1206 = /*#__PURE__*/React.createElement("rect", {
    x: 45,
    y: 29,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect1207 || (_rect1207 = /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 30,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect1208 || (_rect1208 = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 30,
    width: 1,
    height: 1,
    fill: "#8F974A"
  })), _rect1209 || (_rect1209 = /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 30,
    width: 1,
    height: 1,
    fill: "#323C39"
  })), _rect1210 || (_rect1210 = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 30,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect1211 || (_rect1211 = /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 30,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect1212 || (_rect1212 = /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 30,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect1213 || (_rect1213 = /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 30,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect1214 || (_rect1214 = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 30,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect1215 || (_rect1215 = /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 30,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect1216 || (_rect1216 = /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 30,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect1217 || (_rect1217 = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 30,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect1218 || (_rect1218 = /*#__PURE__*/React.createElement("rect", {
    x: 21,
    y: 30,
    width: 1,
    height: 1,
    fill: "#CBDBFC"
  })), _rect1219 || (_rect1219 = /*#__PURE__*/React.createElement("rect", {
    x: 22,
    y: 30,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect1220 || (_rect1220 = /*#__PURE__*/React.createElement("rect", {
    x: 23,
    y: 30,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect1221 || (_rect1221 = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 30,
    width: 1,
    height: 1,
    fill: "#CBDBFC"
  })), _rect1222 || (_rect1222 = /*#__PURE__*/React.createElement("rect", {
    x: 25,
    y: 30,
    width: 1,
    height: 1,
    fill: "#CBDBFC"
  })), _rect1223 || (_rect1223 = /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 30,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect1224 || (_rect1224 = /*#__PURE__*/React.createElement("rect", {
    x: 27,
    y: 30,
    width: 1,
    height: 1,
    fill: "#CBDBFC"
  })), _rect1225 || (_rect1225 = /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 30,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect1226 || (_rect1226 = /*#__PURE__*/React.createElement("rect", {
    x: 29,
    y: 30,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect1227 || (_rect1227 = /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 30,
    width: 1,
    height: 1,
    fill: "#CBDBFC"
  })), _rect1228 || (_rect1228 = /*#__PURE__*/React.createElement("rect", {
    x: 31,
    y: 30,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect1229 || (_rect1229 = /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 30,
    width: 1,
    height: 1,
    fill: "#CBDBFC"
  })), _rect1230 || (_rect1230 = /*#__PURE__*/React.createElement("rect", {
    x: 33,
    y: 30,
    width: 1,
    height: 1,
    fill: "#CBDBFC"
  })), _rect1231 || (_rect1231 = /*#__PURE__*/React.createElement("rect", {
    x: 34,
    y: 30,
    width: 1,
    height: 1,
    fill: "#CBDBFC"
  })), _rect1232 || (_rect1232 = /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 30,
    width: 1,
    height: 1,
    fill: "#CBDBFC"
  })), _rect1233 || (_rect1233 = /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 30,
    width: 1,
    height: 1,
    fill: "#CBDBFC"
  })), _rect1234 || (_rect1234 = /*#__PURE__*/React.createElement("rect", {
    x: 37,
    y: 30,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect1235 || (_rect1235 = /*#__PURE__*/React.createElement("rect", {
    x: 38,
    y: 30,
    width: 1,
    height: 1,
    fill: "#CBDBFC"
  })), _rect1236 || (_rect1236 = /*#__PURE__*/React.createElement("rect", {
    x: 39,
    y: 30,
    width: 1,
    height: 1,
    fill: "#CBDBFC"
  })), _rect1237 || (_rect1237 = /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 30,
    width: 1,
    height: 1,
    fill: "#CBDBFC"
  })), _rect1238 || (_rect1238 = /*#__PURE__*/React.createElement("rect", {
    x: 41,
    y: 30,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect1239 || (_rect1239 = /*#__PURE__*/React.createElement("rect", {
    x: 42,
    y: 30,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect1240 || (_rect1240 = /*#__PURE__*/React.createElement("rect", {
    x: 43,
    y: 30,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect1241 || (_rect1241 = /*#__PURE__*/React.createElement("rect", {
    x: 44,
    y: 30,
    width: 1,
    height: 1,
    fill: "#CBDBFC"
  })), _rect1242 || (_rect1242 = /*#__PURE__*/React.createElement("rect", {
    x: 45,
    y: 30,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect1243 || (_rect1243 = /*#__PURE__*/React.createElement("rect", {
    x: 47,
    y: 30,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect1244 || (_rect1244 = /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 30,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect1245 || (_rect1245 = /*#__PURE__*/React.createElement("rect", {
    x: 49,
    y: 30,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect1246 || (_rect1246 = /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 31,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect1247 || (_rect1247 = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 31,
    width: 1,
    height: 1,
    fill: "#8F974A"
  })), _rect1248 || (_rect1248 = /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 31,
    width: 1,
    height: 1,
    fill: "#323C39"
  })), _rect1249 || (_rect1249 = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 31,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect1250 || (_rect1250 = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 31,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect1251 || (_rect1251 = /*#__PURE__*/React.createElement("rect", {
    x: 21,
    y: 31,
    width: 1,
    height: 1,
    fill: "#CBDBFC"
  })), _rect1252 || (_rect1252 = /*#__PURE__*/React.createElement("rect", {
    x: 22,
    y: 31,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect1253 || (_rect1253 = /*#__PURE__*/React.createElement("rect", {
    x: 23,
    y: 31,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect1254 || (_rect1254 = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 31,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect1255 || (_rect1255 = /*#__PURE__*/React.createElement("rect", {
    x: 25,
    y: 31,
    width: 1,
    height: 1,
    fill: "#CBDBFC"
  })), _rect1256 || (_rect1256 = /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 31,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect1257 || (_rect1257 = /*#__PURE__*/React.createElement("rect", {
    x: 27,
    y: 31,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect1258 || (_rect1258 = /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 31,
    width: 1,
    height: 1,
    fill: "#CBDBFC"
  })), _rect1259 || (_rect1259 = /*#__PURE__*/React.createElement("rect", {
    x: 29,
    y: 31,
    width: 1,
    height: 1,
    fill: "#CBDBFC"
  })), _rect1260 || (_rect1260 = /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 31,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect1261 || (_rect1261 = /*#__PURE__*/React.createElement("rect", {
    x: 31,
    y: 31,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect1262 || (_rect1262 = /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 31,
    width: 1,
    height: 1,
    fill: "#CBDBFC"
  })), _rect1263 || (_rect1263 = /*#__PURE__*/React.createElement("rect", {
    x: 33,
    y: 31,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect1264 || (_rect1264 = /*#__PURE__*/React.createElement("rect", {
    x: 34,
    y: 31,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect1265 || (_rect1265 = /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 31,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect1266 || (_rect1266 = /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 31,
    width: 1,
    height: 1,
    fill: "#CBDBFC"
  })), _rect1267 || (_rect1267 = /*#__PURE__*/React.createElement("rect", {
    x: 37,
    y: 31,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect1268 || (_rect1268 = /*#__PURE__*/React.createElement("rect", {
    x: 38,
    y: 31,
    width: 1,
    height: 1,
    fill: "#CBDBFC"
  })), _rect1269 || (_rect1269 = /*#__PURE__*/React.createElement("rect", {
    x: 39,
    y: 31,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect1270 || (_rect1270 = /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 31,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect1271 || (_rect1271 = /*#__PURE__*/React.createElement("rect", {
    x: 41,
    y: 31,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect1272 || (_rect1272 = /*#__PURE__*/React.createElement("rect", {
    x: 42,
    y: 31,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect1273 || (_rect1273 = /*#__PURE__*/React.createElement("rect", {
    x: 43,
    y: 31,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect1274 || (_rect1274 = /*#__PURE__*/React.createElement("rect", {
    x: 44,
    y: 31,
    width: 1,
    height: 1,
    fill: "#CBDBFC"
  })), _rect1275 || (_rect1275 = /*#__PURE__*/React.createElement("rect", {
    x: 45,
    y: 31,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect1276 || (_rect1276 = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 32,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect1277 || (_rect1277 = /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 32,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect1278 || (_rect1278 = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 32,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect1279 || (_rect1279 = /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 32,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect1280 || (_rect1280 = /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 32,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect1281 || (_rect1281 = /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 32,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect1282 || (_rect1282 = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 32,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect1283 || (_rect1283 = /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 32,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect1284 || (_rect1284 = /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 32,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect1285 || (_rect1285 = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 32,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect1286 || (_rect1286 = /*#__PURE__*/React.createElement("rect", {
    x: 21,
    y: 32,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect1287 || (_rect1287 = /*#__PURE__*/React.createElement("rect", {
    x: 22,
    y: 32,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect1288 || (_rect1288 = /*#__PURE__*/React.createElement("rect", {
    x: 23,
    y: 32,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect1289 || (_rect1289 = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 32,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect1290 || (_rect1290 = /*#__PURE__*/React.createElement("rect", {
    x: 25,
    y: 32,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect1291 || (_rect1291 = /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 32,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect1292 || (_rect1292 = /*#__PURE__*/React.createElement("rect", {
    x: 27,
    y: 32,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect1293 || (_rect1293 = /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 32,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect1294 || (_rect1294 = /*#__PURE__*/React.createElement("rect", {
    x: 29,
    y: 32,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect1295 || (_rect1295 = /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 32,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect1296 || (_rect1296 = /*#__PURE__*/React.createElement("rect", {
    x: 31,
    y: 32,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect1297 || (_rect1297 = /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 32,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect1298 || (_rect1298 = /*#__PURE__*/React.createElement("rect", {
    x: 33,
    y: 32,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect1299 || (_rect1299 = /*#__PURE__*/React.createElement("rect", {
    x: 34,
    y: 32,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect1300 || (_rect1300 = /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 32,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect1301 || (_rect1301 = /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 32,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect1302 || (_rect1302 = /*#__PURE__*/React.createElement("rect", {
    x: 37,
    y: 32,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect1303 || (_rect1303 = /*#__PURE__*/React.createElement("rect", {
    x: 38,
    y: 32,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect1304 || (_rect1304 = /*#__PURE__*/React.createElement("rect", {
    x: 39,
    y: 32,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect1305 || (_rect1305 = /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 32,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect1306 || (_rect1306 = /*#__PURE__*/React.createElement("rect", {
    x: 41,
    y: 32,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect1307 || (_rect1307 = /*#__PURE__*/React.createElement("rect", {
    x: 42,
    y: 32,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect1308 || (_rect1308 = /*#__PURE__*/React.createElement("rect", {
    x: 43,
    y: 32,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect1309 || (_rect1309 = /*#__PURE__*/React.createElement("rect", {
    x: 44,
    y: 32,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect1310 || (_rect1310 = /*#__PURE__*/React.createElement("rect", {
    x: 45,
    y: 32,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect1311 || (_rect1311 = /*#__PURE__*/React.createElement("rect", {
    x: 47,
    y: 32,
    width: 1,
    height: 1,
    fill: "#222034"
  })), _rect1312 || (_rect1312 = /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 32,
    width: 1,
    height: 1,
    fill: "#222034"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOnchainLogo);
export default __webpack_public_path__ + "static/media/onchain-logo.461331fe6f081cf0945cff14c6855756.svg";
export { ForwardRef as ReactComponent };